import { useLanguage } from '../contexts/LanguageContext';
import { multiIndustryTranslations } from './multiIndustryTranslations';

/**
 * قاموس ترجمة واجهة الموقع (الأزرار، القوائم، الرسائل الثابتة).
 * ملحوظة: النصوص التسويقية اللي بتولّدها الذكاء الاصطناعي (استراتيجية الاستهداف،
 * النسخ الإعلانية) بتفضل عربي دايماً بغض النظر عن اللغة، لأنها المنتج النهائي
 * المُوجّه لسوق عربي (مصر والخليج) — مش جزء من واجهة الموقع نفسها.
 */
export const translations = {
  ar: {
    // Sidebar / Nav
    'nav.builder': 'مولد الحملات',
    'nav.saved': 'الحملات المحفوظة',
    'nav.library': 'مكتبة المحتوى',
    'nav.insights': 'استراتيجيات CPL',
    'nav.admin': 'لوحة المالك',
    'nav.dashboard': 'الرئيسية',
    'tab.dashboard': 'مساحة العمل',
    'tab.library': 'مكتبة النصوص والزوايا',
    'nav.team': 'فريق العمل',
    'tab.team': 'مساحة الفريق',
    'nav.chat': 'شات الذكاء الاصطناعي',
    'nav.newProject': 'حملة جديدة',
    'nav.quickSearch': 'بحث سريع...',
    'nav.recentChats': 'المحادثات الأخيرة',
    'nav.searchProjects': 'بحث في المشاريع...',
    'nav.noSavedProjects': 'لا توجد مشاريع محفوظة بعد',
    'nav.upgradePlan': 'ترقية الباقة',
    'nav.lightMode': 'الوضع الفاتح',
    'nav.darkMode': 'الوضع الداكن',
    'nav.logout': 'تسجيل الخروج',
    'nav.closeMenu': 'إغلاق القائمة',
    'nav.unlimited': 'غير محدود',
    'nav.credits': 'رصيد',
    'nav.planFree': 'المجانية',

    // TopBar
    'topbar.openMenu': 'فتح القائمة',
    'topbar.upgrade': 'ترقية',

    // Auth
    'auth.registerTitle': 'إنشاء حساب جديد',
    'auth.subtitle': 'يجب إنشاء حساب أو تسجيل الدخول لاستخدام الموقع',
    'auth.tabNew': 'حساب جديد',
    'auth.tabLogin': 'تسجيل الدخول',
    'auth.freeNoticeTitle': 'نسخة مجانية:',
    'auth.freeNoticeBody': 'عند التسجيل سيتم إنشاء حسابك النسخة المجانية مع 3 رصيد حملات مجانية.',
    'auth.name': 'الاسم بالكامل',
    'auth.namePlaceholder': 'مثال: أحمد محمود',
    'auth.email': 'البريد الإلكتروني',
    'auth.phone': 'رقم الهاتف',
    'auth.password': 'كلمة المرور',
    'auth.loginButton': 'تسجيل الدخول',
    'auth.registerButton': 'إنشاء حساب مجاني',
    'auth.creating': 'جاري الإنشاء...',
    'auth.verifying': 'جاري التحقق...',
    'auth.loading': 'جاري التحميل...',

    // Profile
    'profile.title': 'الملف الشخصي',
    'profile.subtitle': 'إدارة بياناتك وإعدادات حسابك',
    'profile.changePhoto': 'تغيير الصورة',
    'profile.removePhoto': 'إزالة الصورة',
    'profile.avatarError': 'يرجى اختيار صورة صالحة (PNG أو JPEG أو WebP) بحجم أقل من 5 ميجابايت',
    'profile.generalSection': 'البيانات الأساسية',
    'profile.name': 'الاسم بالكامل',
    'profile.dateOfBirth': 'تاريخ الميلاد',
    'profile.saveChanges': 'حفظ التغييرات',
    'profile.saving': 'جاري الحفظ...',
    'profile.profileUpdated': 'تم تحديث بياناتك بنجاح',
    'profile.emailSection': 'البريد الإلكتروني',
    'profile.currentEmail': 'البريد الحالي',
    'profile.verified': 'مفعّل',
    'profile.notVerified': 'غير مفعّل',
    'profile.newEmail': 'البريد الإلكتروني الجديد',
    'profile.confirmPassword': 'كلمة المرور الحالية (للتأكيد)',
    'profile.changeEmailButton': 'تغيير البريد الإلكتروني',
    'profile.emailChangeSent': 'تم إرسال كود تفعيل إلى بريدك الجديد',
    'profile.enterCode': 'أدخل كود التفعيل',
    'profile.verifyButton': 'تأكيد الكود',
    'profile.resendCode': 'إعادة إرسال الكود',
    'profile.emailVerifiedSuccess': 'تم تفعيل بريدك الإلكتروني الجديد بنجاح',
    'profile.passwordSection': 'كلمة المرور',
    'profile.currentPassword': 'كلمة المرور الحالية',
    'profile.newPassword': 'كلمة المرور الجديدة',
    'profile.confirmNewPassword': 'تأكيد كلمة المرور الجديدة',
    'profile.changePasswordButton': 'تغيير كلمة المرور',
    'profile.passwordChanged': 'تم تغيير كلمة المرور بنجاح',
    'profile.passwordMismatch': 'كلمتا المرور غير متطابقتين',
    'profile.dangerSection': 'منطقة الخطر',
    'profile.dangerBody': 'حذف حسابك نهائي ولا يمكن التراجع عنه. سيتم حذف كل حملاتك المحفوظة ومحادثاتك وبياناتك بشكل كامل.',
    'profile.deleteAccountButton': 'حذف الحساب نهائياً',
    'profile.deleteConfirmTitle': 'تأكيد حذف الحساب',
    'profile.deleteConfirmBody': 'هذا الإجراء لا يمكن التراجع عنه. أدخل كلمة المرور لتأكيد حذف حسابك نهائياً.',
    'profile.deleteConfirmButton': 'تأكيد الحذف نهائياً',
    'profile.cancel': 'إلغاء',
    'profile.close': 'إغلاق',

    // Pricing
    'pricing.badge': 'ترقية الباقات والحسابات',
    'pricing.heading': 'اختر الباقة المناسبة لحجم حملاتك التسويقية',
    'pricing.subheading': 'تتم الترقية يدوياً بواسطة مالك الموقع لضمان أعلى مستوى من المتابعة والدعم الفني المباشر',
    'pricing.perMonth': 'جنيه / شهرياً',
    'pricing.free.badge': 'تجربة مجانية تلقائية',
    'pricing.free.desc': 'الباقة الافتراضية التلقائية لكل مستخدم جديد عند تسجيل الحساب.',
    'pricing.free.feature1': '3 حملات مجانية أولية',
    'pricing.free.feature2': 'استراتيجيات استهداف Meta كاملة',
    'pricing.free.feature3': '3 زوايا إعلانية بالعامية المصرية',
    'pricing.free.currentButton': 'الباقة الحالية (النشطة)',
    'pricing.pro.mostPopular': 'الأكثر طلباً',
    'pricing.pro.badge': 'للمسوقين المستقلين',
    'pricing.pro.desc': 'مثالي للمسوق المستقل للتوليد اليومي السريع ورصيد حملات مناسب.',
    'pricing.pro.feature1': '50 حملات واستراتيجيات',
    'pricing.pro.feature2': 'قوالب واستهداف متعدد المجالات',
    'pricing.pro.feature3': 'تفعيل سريع',
    'pricing.pro.currentButton': 'الباقة الحالية',
    'pricing.agency.badge': 'للوكالات والفرق',
    'pricing.agency.desc': 'لوكالات التسويق وفرق الحملات والمبيعات الكبيرة.',
    'pricing.agency.feature1': 'كل مميزات Pro + حسابات فريق متعددة',
    'pricing.agency.feature2': 'تحليل CPL مخصص للمنافسين',
    'pricing.agency.feature3': 'دعم مباشر وخاص من الوكيل',
    'pricing.agency.currentButton': 'الباقة الحالية',

    
    // ROI Calculator
    'roi.title': 'حاسبة العائد والتنبؤ الذكي',
    'roi.subtitle': 'ROI & Lead Budget Calculator',
    'roi.leadsPerMonth': 'ليد / شهر',
    'roi.monthlyBudget': 'الميزانية الشهرية',
    'roi.unitPrice': 'سعر الوحدة',
    'roi.closingRate': 'نسبة الإغلاق المتوقعة',
    'roi.expectedLeads': 'ليد متوقع / شهر',
    'roi.potentialMeetings': 'مقابلة محتملة',
    'roi.meetingsDesc': '40% من الليدات',
    'roi.expectedDeals': 'صفقة متوقعة',
    'roi.dealsDesc': 'نسبة {rate}% إغلاق',
    'roi.roas': 'ROAS / عائد إعلاني',
    'roi.roasDesc': 'Return on Ad Spend',
    'roi.totalSales': 'إجمالي المبيعات المتوقعة / شهر',
    'roi.commission': 'عمولة البيع المتوقعة (2.5%)',
    'roi.adSpend': 'الإنفاق الإعلاني',
    'roi.disclaimer': 'الأرقام تقديرية استناداً إلى متوسطات سوق الإعلانات العقارية المصرية وليست ضماناً بنتائج فعلية.',
    'roi.currency': 'ج.م',
    'roi.currencyShort': 'ج.م',

    // Market Insights Extras
    'insights.demandLevel': 'مستوى الطلب',
    'insights.priceIndex': 'مؤشر الأسعار',
    'insights.adBenchmarks': 'بنشمارك الإعلانات',
    'insights.metaPolicyTab': 'سياسة Meta',
    'insights.annually': 'سنوياً',
    'insights.priceRange': 'نطاق السعر',
    'insights.avgPricePerMeter': 'متوسط السعر / م²',
    'insights.annualPriceGrowth': 'نمو سنوي في الأسعار',
    'insights.avgRentStr': 'متوسط الإيجار',
    'insights.buyerProfileLabel': 'الملف الإعلاني للمشتري المستهدف:',
    'insights.propertyTypesLabel': 'أنواع العقارات الأكثر طلباً:',
    'insights.interestsLabel': 'أهم الاهتمامات للاستهداف في Meta Ads:',
    'insights.copyToClipboard': 'اضغط للنسخ',
    'insights.compareRegions': 'مقارنة المناطق',
    'insights.compareDesc': 'اختر منطقتين للمقارنة المباشرة',
    'insights.region1': 'المنطقة الأولى',
    'insights.region2': 'المنطقة الثانية',
    'insights.selectRegion': '-- اختر منطقة --',
    'insights.loadingTitle': 'جاري تحليل السوق بالذكاء الاصطناعي...',
    'insights.loadingSubtitle': 'بنجهّز مؤشرات الأسعار وبنشمارك الـ CPL لحظياً',
    'insights.errorTitle': 'تعذر تحميل تحليلات السوق',
    'insights.retry': 'إعادة المحاولة',
    'insights.aiGeneratedBadge': 'مولّد بالذكاء الاصطناعي',
    'insights.estimateDisclaimer': 'الأرقام تقديرات تحليلية بالذكاء الاصطناعي، وليست بيانات حية من Meta Ads Manager.',
    'insights.generatedAt': 'آخر تحديث',
    'insights.paywallTitle': 'استراتيجيات CPL متاحة للباقات المدفوعة',
    'insights.paywallSubtitle': 'ترقّى لباقة Pro أو Agency عشان توصل لتحليلات السوق ومؤشرات CPL بالذكاء الاصطناعي، محدّثة أول ما تفتح الصفحة.',
    'insights.paywallCta': 'الترقية للباقة المدفوعة',

    // Strategy Results Extras

    
    // ROI Calculator

    // Market Insights Extras

    // Strategy Results Extras

    
    // Strategy Results Extras 2
    'results.reelsScript': 'سكريبت Reels / TikTok',
    'results.generateVideoScript': 'توليد سكريبت فيديو 30-60 ثانية',
    'results.multiPlatformAds': 'إعلانات متعددة المنصات',
    'results.competitorAdsAnalyzer': 'محلل إعلانات المنافسين',
    'results.analysisStrategy': 'تحليل وإستراتيجية مضادة',
    'results.rewritten': 'معاد صياغته',
    'results.restoreOriginal': 'استعادة النص الأصلي',
    'results.rewriteBtn': 'أعد الصياغة',
    'results.shorter': 'أكثر اختصاراً',
    'results.focusInstallments': 'ركّز على التقسيط',
    'results.luxuryStyle': 'أسلوب فاخر',
    'results.egyptianColloquial': 'عامية مصرية',
    'results.gulfDialect': 'اللهجة الخليجية',
    'results.urgency': 'ضغط وإلحاح',

    
    // Auth Extras
    'auth.activationSent': 'تم إرسال كود التفعيل إلى بريدك الإلكتروني.',
    'auth.fillRequired': 'برجاء ملء جميع الحقول المطلوبة بشكل صحيح.',
    'auth.passMinLength': 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.',
    'auth.registerError': 'حدث خطأ أثناء إنشاء الحساب، برجاء المحاولة مرة أخرى.',
    'auth.loginError': 'حدث خطأ أثناء تسجيل الدخول، برجاء المحاولة مرة أخرى.',
    'auth.enterActivation': 'برجاء إدخال كود التفعيل المكوّن من 6 أرقام.',
    'auth.accountActivated': 'تم تفعيل حسابك بنجاح! جاري تحويلك للموقع...',
    'auth.invalidCode': 'كود التفعيل غير صحيح، برجاء المحاولة مرة أخرى.',
    'auth.newCodeSent': 'تم إرسال كود تفعيل جديد إلى بريدك الإلكتروني.',
    'auth.resendError': 'تعذر إعادة إرسال الكود، حاول لاحقاً.',
    'auth.enterEmail': 'برجاء إدخال البريد الإلكتروني.',
    'auth.resetCodeSent': 'تم إرسال كود إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.',
    'auth.resetError': 'تعذر إرسال كود إعادة التعيين، برجاء المحاولة مرة أخرى.',
    'auth.enterVerifyCode': 'برجاء إدخال كود التحقق المكوّن من 6 أرقام.',
    'auth.passwordsNotMatch': 'كلمتا المرور غير متطابقتين.',
    'auth.passUpdated': 'تم تحديث كلمة المرور بنجاح! جاري تحويلك للموقع...',
    'auth.passUpdateError': 'تعذر إعادة تعيين كلمة المرور، برجاء المحاولة مرة أخرى.',
    'auth.verifyEmailTab': 'تفعيل البريد الإلكتروني',
    'auth.resetPassTab': 'استعادة كلمة المرور',
    'auth.codeSentTo': 'تم إرسال كود مكوّن من 6 أرقام إلى',
    'auth.validFor10Mins': 'صالح لمدة 10 دقائق.',
    'auth.activationCode': 'كود التفعيل',
    'auth.activateAccount': 'تفعيل الحساب',
    'auth.back': '← رجوع',
    'auth.resetPassDesc': 'أدخل البريد الإلكتروني المسجل والمُفعّل لحسابك، وسنرسل لك كود إعادة تعيين كلمة المرور.',
    'auth.sending': 'جاري الإرسال...',
    'auth.sendResetCode': 'إرسال كود إعادة التعيين',
    'auth.backToLogin': '← رجوع لتسجيل الدخول',
    'auth.verifyCode': 'كود التحقق',
    'auth.newPassword': 'كلمة المرور الجديدة',
    'auth.saving': 'جاري الحفظ...',
    'auth.updatePassword': 'تحديث كلمة المرور',
    'auth.forgotPassword': 'نسيت كلمة المرور؟',

    // Common
    'common.close': 'إغلاق',
    'common.cancel': 'إلغاء',
    'common.language': 'English',

    // Project Form
    'form.projectNamePlaceholder': 'مثال: سوديك فيليت',
    'form.developerNamePlaceholder': 'مثال: SODIC',
    'form.subAreaPlaceholder': 'مثال: الكيلو 185',
    'form.unitDetailsPlaceholder': 'مثال: شقة 3 غرف 165م',
    'form.errorProjectName': 'يرجى إدخال اسم المشروع',

    // Strategy Results
    'results.successBadge': 'تم توليد الاستراتيجية',
    'results.planFor': 'خطة استهداف',
    'results.subheading': 'استراتيجية جاهزة للنسخ المباشر في Meta Ads Manager',
    'results.saveCampaign': 'حفظ الحملة',
    'results.saved': 'محفوظة',
    'results.exportReport': 'تصدير التقرير',
    'results.adCopiesHeading': 'النسخ الإعلانية',
    'results.hook': 'الجملة الافتتاحية',
    'results.copy': 'نسخ',
    'results.primaryText': 'النص الأساسي',
    'results.textCopied': 'تم النسخ!',
    'results.copyText': 'نسخ النص',
    'results.headline': 'العنوان',
    'results.description': 'الوصف',
    'results.imageIdea': 'فكرة الصورة',
    'results.livePreview': 'معاينة حية',
    'results.targetingHeading': 'استهداف ميتا',
    'results.geoRegion': 'المنطقة الجغرافية',
    'results.interests': 'الاهتمامات',
    'results.behaviors': 'السلوكيات',
    'results.expectedCpl': 'تكلفة الليد المتوقعة',
    'results.cplEstimateNote': 'تقدير بناءاً على أداء حملات مشابهة',
    'results.segmentAnalysis': 'تحليل الشريحة',
    'results.ageRange': 'العمر',
    'results.gender': 'الجنس',
    'results.directExport': 'تصدير مباشر',
    'results.readyToLaunch': 'جاهز للإطلاق؟',
    'results.exportedReady': 'الكلمات والنسخ جاهزة للنقل المباشر',
    'results.copiedAll': 'تم نسخ الكل',
    'results.copyAllInterests': 'نسخ كل الاهتمامات',
    'results.metaPolicy': 'سياسات ميتا',
    'results.housingCategory': 'فئة الإسكان الخاصة',
    'results.exclusions': 'الاستبعادات',

    // Command Palette
    'cmd.quickActions': 'إجراءات سريعة',
    'cmd.navigation': 'التنقل',
    'cmd.openProject': 'فتح المشروع',
    'cmd.searchPlaceholder': 'ابحث...',
    'cmd.noResults': 'لا توجد نتائج مطابقة',
    'cmd.switchToLight': 'التبديل إلى الوضع الفاتح',
    'cmd.switchToDark': 'التبديل إلى الوضع الداكن',
    'cmd.goToBuilder': 'الذهاب إلى مولد الحملات',

    // Campaign History
    'history.title': 'الحملات المحفوظة',
    'history.newCampaign': 'حملة جديدة',
    'history.searchPlaceholder': 'ابحث بالاسم أو المنطقة...',
    'history.noResults': 'لا توجد حملات مطابقة',
    'history.noResultsDesc': 'احفظ حملاتك للرجوع إليها لاحقاً',
    'history.startNow': 'ابدأ الآن',
    'history.unit': 'الوحدة',
    'history.notSpecified': 'غير محدد',
    'history.property': 'عقار',
    'history.basePrice': 'السعر الأساسي',
    'history.years': 'سنوات',
    'history.viewStrategy': 'عرض',
    'history.deleteCampaign': 'حذف الحملة',

    // Market Insights
    'insights.avgCpl': 'متوسط CPL',
    'insights.topInterests': 'أفضل الاهتمامات تحويلاً:',
    'insights.recommendedGoal': 'الهدف الموصى به:',
    'insights.policyTitle': 'سياسات ميتا للعقارات',
    'insights.policySubtitle': 'لتجنب حظر حسابك الإعلاني من أول محاولة',

    // Ad Preview Modal
    'preview.title': 'معاينة الإعلان',
    'preview.facebook': 'فيسبوك',
    'preview.instagram': 'إنستجرام',
    'preview.footerNote': 'المظهر مطابق للعرض الفعلي داخل خلاصة Meta',

    // Loading / Skeletons
    'loading.ariaLabel': 'جاري انشاء الاستراتيجية',
    'loading.building': 'جاري بناء استراتيجية الاستهداف...',
    'loading.eta': 'عادة ما تستغرق العملية ثواني معدودة',

    // Hero & Shell
    'hero.badge': 'محرك الحملات متعدد المجالات بالذكاء الاصطناعي',
    'hero.heading': 'مرحباً بك في استهداف ...',
    'hero.subtitle': 'اختر مجال حملتك، وأدخل تفاصيل العرض، واحصل على استهداف ونسخ إعلانية مناسبة خلال ثوانٍ.',
    'footer.rights': 'جميع الحقوق محفوظة',
    'tab.builder': 'مولد الحملات',
    'tab.saved': 'المشاريع المحفوظة',
    'tab.insights': 'استراتيجيات CPL',
    'tab.admin': 'لوحة المالك',
    'tab.chat': 'شات الذكاء الاصطناعي',
    
    // AI Chat
    'chat.newChat': 'محادثة جديدة',
    'chat.title': 'مساعد التسويق الذكي',
    'chat.placeholder': 'اسألني أي شيء يخص التسويق والإعلانات...',
    'chat.attachImage': 'إرفاق صورة',
    'chat.speak': 'تحدث',
    'chat.speechNotSupported': 'التعرف على الصوت غير مدعوم في هذا المتصفح',

    // Image Gen
  },
  en: {
    // Sidebar / Nav
    'nav.builder': 'Campaign Generator',
    'nav.saved': 'Saved Campaigns',
    'nav.library': 'Content Library',
    'nav.insights': 'CPL Insights',
    'nav.admin': 'Owner Dashboard',
    'nav.dashboard': 'Dashboard',
    'tab.dashboard': 'Workspace',
    'tab.library': 'Copy & Angle Library',
    'nav.team': 'Team',
    'tab.team': 'Team Workspace',
    'nav.chat': 'AI Chat',
    'nav.newProject': 'New Campaign',
    'nav.quickSearch': 'Quick search...',
    'nav.recentChats': 'Recent Projects',
    'nav.searchProjects': 'Search projects...',
    'nav.noSavedProjects': 'No saved projects yet',
    'nav.upgradePlan': 'Upgrade Plan',
    'nav.lightMode': 'Light Mode',
    'nav.darkMode': 'Dark Mode',
    'nav.logout': 'Log Out',
    'nav.closeMenu': 'Close Menu',
    'nav.unlimited': 'Unlimited',
    'nav.credits': 'credits',
    'nav.planFree': 'Free',

    // TopBar
    'topbar.openMenu': 'Open Menu',
    'topbar.upgrade': 'Upgrade',

    // Auth
    'auth.registerTitle': 'Create New Account',
    'auth.subtitle': 'Create an account or log in to use the site',
    'auth.tabNew': 'New Account',
    'auth.tabLogin': 'Log In',
    'auth.freeNoticeTitle': 'Free Plan:',
    'auth.freeNoticeBody': 'Signing up creates a free account with 3 free campaign credits.',
    'auth.name': 'Full Name',
    'auth.namePlaceholder': 'e.g. Ahmed Mahmoud',
    'auth.email': 'Email',
    'auth.phone': 'Phone Number',
    'auth.password': 'Password',
    'auth.loginButton': 'Log In',
    'auth.registerButton': 'Create Free Account',
    'auth.creating': 'Creating...',
    'auth.verifying': 'Verifying...',
    'auth.loading': 'Loading...',

    // Profile
    'profile.title': 'Profile',
    'profile.subtitle': 'Manage your info and account settings',
    'profile.changePhoto': 'Change Photo',
    'profile.removePhoto': 'Remove Photo',
    'profile.avatarError': 'Please choose a valid image (PNG, JPEG or WebP) under 5MB',
    'profile.generalSection': 'Basic Info',
    'profile.name': 'Full Name',
    'profile.dateOfBirth': 'Date of Birth',
    'profile.saveChanges': 'Save Changes',
    'profile.saving': 'Saving...',
    'profile.profileUpdated': 'Your info was updated successfully',
    'profile.emailSection': 'Email Address',
    'profile.currentEmail': 'Current Email',
    'profile.verified': 'Verified',
    'profile.notVerified': 'Not Verified',
    'profile.newEmail': 'New Email Address',
    'profile.confirmPassword': 'Current Password (to confirm)',
    'profile.changeEmailButton': 'Change Email',
    'profile.emailChangeSent': 'A verification code was sent to your new email',
    'profile.enterCode': 'Enter Verification Code',
    'profile.verifyButton': 'Verify Code',
    'profile.resendCode': 'Resend Code',
    'profile.emailVerifiedSuccess': 'Your new email was verified successfully',
    'profile.passwordSection': 'Password',
    'profile.currentPassword': 'Current Password',
    'profile.newPassword': 'New Password',
    'profile.confirmNewPassword': 'Confirm New Password',
    'profile.changePasswordButton': 'Change Password',
    'profile.passwordChanged': 'Password changed successfully',
    'profile.passwordMismatch': 'Passwords do not match',
    'profile.dangerSection': 'Danger Zone',
    'profile.dangerBody': 'Deleting your account is permanent and cannot be undone. All your saved campaigns, chats, and data will be permanently removed.',
    'profile.deleteAccountButton': 'Delete Account Permanently',
    'profile.deleteConfirmTitle': 'Confirm Account Deletion',
    'profile.deleteConfirmBody': 'This action cannot be undone. Enter your password to permanently delete your account.',
    'profile.deleteConfirmButton': 'Permanently Delete',
    'profile.cancel': 'Cancel',
    'profile.close': 'Close',

    // Pricing
    'pricing.badge': 'Plan & Account Upgrades',
    'pricing.heading': 'Choose the plan that fits your campaign volume',
    'pricing.subheading': 'Upgrades are handled manually by the site owner to guarantee direct, hands-on support',
    'pricing.perMonth': 'EGP / month',
    'pricing.free.badge': 'Automatic Free Trial',
    'pricing.free.desc': 'The default plan automatically given to every new user upon signup.',
    'pricing.free.feature1': '3 initial free campaigns',
    'pricing.free.feature2': 'Full Meta targeting strategies',
    'pricing.free.feature3': '3 ad copy angles in Egyptian dialect',
    'pricing.free.currentButton': 'Current Plan (Active)',
    'pricing.pro.mostPopular': 'Most Popular',
    'pricing.pro.badge': 'For Independent Marketers',
    'pricing.pro.desc': 'Ideal for independent marketers who need fast daily generation and practical campaign credits.',
    'pricing.pro.feature1': '50 campaigns & strategies',
    'pricing.pro.feature2': 'Multi-industry templates and targeting',
    'pricing.pro.feature3': 'Fast activation',
    'pricing.pro.currentButton': 'Current Plan',
    'pricing.agency.badge': 'For Agencies & Teams',
    'pricing.agency.desc': 'For marketing agencies and larger campaign and sales teams.',
    'pricing.agency.feature1': 'Everything in Pro + multiple team accounts',
    'pricing.agency.feature2': 'Custom competitor CPL analysis',
    'pricing.agency.feature3': 'Direct, dedicated agent support',
    'pricing.agency.currentButton': 'Current Plan',

    
    // ROI Calculator
    'roi.title': 'ROI & Smart Forecast Calculator',
    'roi.subtitle': 'ROI & Lead Budget Calculator',
    'roi.leadsPerMonth': 'leads / month',
    'roi.monthlyBudget': 'Monthly Budget',
    'roi.unitPrice': 'Unit Price',
    'roi.closingRate': 'Expected Closing Rate',
    'roi.expectedLeads': 'Expected Leads / Month',
    'roi.potentialMeetings': 'Potential Meetings',
    'roi.meetingsDesc': '40% of leads',
    'roi.expectedDeals': 'Expected Deals',
    'roi.dealsDesc': '{rate}% closing rate',
    'roi.roas': 'ROAS',
    'roi.roasDesc': 'Return on Ad Spend',
    'roi.totalSales': 'Total Expected Sales / Month',
    'roi.commission': 'Expected Commission (2.5%)',
    'roi.adSpend': 'Ad Spend',
    'roi.disclaimer': 'Figures are estimates based on Egyptian real estate ad market averages and do not guarantee actual results.',
    'roi.currency': 'EGP',
    'roi.currencyShort': 'EGP',

    // Market Insights Extras
    'insights.demandLevel': 'Demand Level',
    'insights.priceIndex': 'Price Index',
    'insights.adBenchmarks': 'Ad Benchmarks',
    'insights.metaPolicyTab': 'Meta Policy',
    'insights.annually': 'annually',
    'insights.priceRange': 'Price Range',
    'insights.avgPricePerMeter': 'Avg Price / m²',
    'insights.annualPriceGrowth': 'Annual Price Growth',
    'insights.avgRentStr': 'Avg Rent',
    'insights.buyerProfileLabel': 'Target Buyer Profile:',
    'insights.propertyTypesLabel': 'Top Property Types:',
    'insights.interestsLabel': 'Top Meta Ads Interests:',
    'insights.copyToClipboard': 'Click to copy',
    'insights.compareRegions': 'Compare Regions',
    'insights.compareDesc': 'Select two regions for direct comparison',
    'insights.region1': 'First Region',
    'insights.region2': 'Second Region',
    'insights.selectRegion': '-- Select Region --',
    'insights.loadingTitle': 'Analyzing the market with AI...',
    'insights.loadingSubtitle': 'Preparing price index and CPL benchmarks live',
    'insights.errorTitle': 'Could not load market insights',
    'insights.retry': 'Retry',
    'insights.aiGeneratedBadge': 'AI-generated',
    'insights.estimateDisclaimer': 'Figures are AI-analyzed estimates, not live data from Meta Ads Manager.',
    'insights.generatedAt': 'Last updated',
    'insights.paywallTitle': 'CPL Strategies is a paid-plan feature',
    'insights.paywallSubtitle': 'Upgrade to Pro or Agency to unlock AI-generated market analytics and CPL benchmarks, refreshed every time you open the page.',
    'insights.paywallCta': 'Upgrade Plan',

    // Strategy Results Extras

    
    // Strategy Results Extras 2
    'results.reelsScript': 'Reels / TikTok Script',
    'results.generateVideoScript': 'Generate 30-60s video script',
    'results.multiPlatformAds': 'Multi-Platform Ads',
    'results.competitorAdsAnalyzer': 'Competitor Ads Analyzer',
    'results.analysisStrategy': 'Analysis & Counter-Strategy',
    'results.rewritten': 'Rewritten',
    'results.restoreOriginal': 'Restore Original Text',
    'results.rewriteBtn': 'Rewrite',
    'results.shorter': 'More Concise',
    'results.focusInstallments': 'Focus on Installments',
    'results.luxuryStyle': 'Luxury Style',
    'results.egyptianColloquial': 'Egyptian Colloquial',
    'results.gulfDialect': 'Gulf Dialect',
    'results.urgency': 'Urgency & Scarcity',

    
    // Auth Extras
    'auth.activationSent': 'Activation code sent to your email.',
    'auth.fillRequired': 'Please fill all required fields correctly.',
    'auth.passMinLength': 'Password must be at least 8 characters.',
    'auth.registerError': 'Error creating account, please try again.',
    'auth.loginError': 'Error logging in, please try again.',
    'auth.enterActivation': 'Please enter the 6-digit activation code.',
    'auth.accountActivated': 'Account activated successfully! Redirecting...',
    'auth.invalidCode': 'Invalid activation code, please try again.',
    'auth.newCodeSent': 'A new activation code was sent to your email.',
    'auth.resendError': 'Could not resend code, try again later.',
    'auth.enterEmail': 'Please enter your email.',
    'auth.resetCodeSent': 'Password reset code sent to your email.',
    'auth.resetError': 'Could not send reset code, please try again.',
    'auth.enterVerifyCode': 'Please enter the 6-digit verification code.',
    'auth.passwordsNotMatch': 'Passwords do not match.',
    'auth.passUpdated': 'Password updated successfully! Redirecting...',
    'auth.passUpdateError': 'Could not reset password, please try again.',
    'auth.verifyEmailTab': 'Email Verification',
    'auth.resetPassTab': 'Reset Password',
    'auth.codeSentTo': 'A 6-digit code has been sent to',
    'auth.validFor10Mins': 'Valid for 10 minutes.',
    'auth.activationCode': 'Activation Code',
    'auth.activateAccount': 'Activate Account',
    'auth.back': '← Back',
    'auth.resetPassDesc': 'Enter your registered email and we will send you a password reset code.',
    'auth.sending': 'Sending...',
    'auth.sendResetCode': 'Send Reset Code',
    'auth.backToLogin': '← Back to Login',
    'auth.verifyCode': 'Verification Code',
    'auth.newPassword': 'New Password',
    'auth.saving': 'Saving...',
    'auth.updatePassword': 'Update Password',
    'auth.forgotPassword': 'Forgot password?',

    // Common
    'common.close': 'Close',
    'common.cancel': 'Cancel',
    'common.language': 'العربية',

    // Project Form
    'form.projectNamePlaceholder': 'e.g. SODIC Villette',
    'form.developerNamePlaceholder': 'e.g. SODIC',
    'form.subAreaPlaceholder': 'e.g. KM 185',
    'form.unitDetailsPlaceholder': 'e.g. 3BR apartment, 165 sqm',
    'form.errorProjectName': 'Please enter the project name',

    // Strategy Results
    'results.successBadge': 'Strategy Generated',
    'results.planFor': 'Targeting Plan for',
    'results.subheading': 'Ready to paste directly into Meta Ads Manager',
    'results.saveCampaign': 'Save Campaign',
    'results.saved': 'Saved',
    'results.exportReport': 'Export Report',
    'results.adCopiesHeading': 'Ad Copies',
    'results.hook': 'Hook',
    'results.copy': 'Copy',
    'results.primaryText': 'Primary Text',
    'results.textCopied': 'Copied!',
    'results.copyText': 'Copy Text',
    'results.headline': 'Headline',
    'results.description': 'Description',
    'results.imageIdea': 'Image Idea',
    'results.livePreview': 'Live Preview',
    'results.targetingHeading': 'Meta Targeting',
    'results.geoRegion': 'Geographic Region',
    'results.interests': 'Interests',
    'results.behaviors': 'Behaviors',
    'results.expectedCpl': 'Expected Cost Per Lead',
    'results.cplEstimateNote': 'Estimate based on similar campaign performance',
    'results.segmentAnalysis': 'Segment Analysis',
    'results.ageRange': 'Age Range',
    'results.gender': 'Gender',
    'results.directExport': 'Direct Export',
    'results.readyToLaunch': 'Ready to launch?',
    'results.exportedReady': 'Keywords and copy ready to paste directly',
    'results.copiedAll': 'All Copied!',
    'results.copyAllInterests': 'Copy All Interests',
    'results.metaPolicy': 'Meta Policy',
    'results.housingCategory': 'Special Housing Category',
    'results.exclusions': 'Exclusions',

    // Command Palette
    'cmd.quickActions': 'Quick Actions',
    'cmd.navigation': 'Navigation',
    'cmd.openProject': 'Open project',
    'cmd.searchPlaceholder': 'Search...',
    'cmd.noResults': 'No matching results',
    'cmd.switchToLight': 'Switch to Light Mode',
    'cmd.switchToDark': 'Switch to Dark Mode',
    'cmd.goToBuilder': 'Go to Campaign Generator',

    // Campaign History
    'history.title': 'Saved Campaigns',
    'history.newCampaign': 'New Campaign',
    'history.searchPlaceholder': 'Search by name or region...',
    'history.noResults': 'No matching campaigns',
    'history.noResultsDesc': 'Save campaigns to come back to them later',
    'history.startNow': 'Start Now',
    'history.unit': 'Unit',
    'history.notSpecified': 'Not specified',
    'history.property': 'Property',
    'history.basePrice': 'Base Price',
    'history.years': 'years',
    'history.viewStrategy': 'View',
    'history.deleteCampaign': 'Delete Campaign',

    // Market Insights
    'insights.avgCpl': 'Avg. CPL',
    'insights.topInterests': 'Top Converting Interests:',
    'insights.recommendedGoal': 'Recommended Goal:',
    'insights.policyTitle': "Meta's Real Estate Policies",
    'insights.policySubtitle': 'Avoid getting your ad account restricted on the first try',

    // Ad Preview Modal
    'preview.title': 'Ad Preview',
    'preview.facebook': 'Facebook',
    'preview.instagram': 'Instagram',
    'preview.footerNote': "Matches the ad's real appearance in the Meta feed",

    // Loading / Skeletons
    'loading.ariaLabel': 'Generating strategy',
    'loading.building': 'Building your targeting strategy...',
    'loading.eta': 'This usually takes just a few seconds',

    // Hero & Shell
    'hero.badge': 'AI-Powered Multi-Industry Campaign Engine',
    'hero.heading': 'Welcome to Istihdaf...',
    'hero.subtitle': 'Choose your campaign industry, enter the offer details, and get tailored targeting and ad copy in seconds.',
    'footer.rights': 'All rights reserved',
    'tab.builder': 'Campaign Generator',
    'tab.saved': 'Saved Projects',
    'tab.insights': 'CPL Insights',
    'tab.admin': 'Owner Dashboard',
    'tab.chat': 'AI Chat',

    // AI Chat
    'chat.newChat': 'New Chat',
    'chat.title': 'Smart Marketing Assistant',
    'chat.placeholder': 'Ask me anything about marketing and ads...',
    'chat.attachImage': 'Attach Image',
    'chat.speak': 'Speak',
    'chat.speechNotSupported': 'Speech recognition is not supported in this browser',

    // Image Gen
  },
} as const;

export type TranslationKey = keyof typeof translations['ar'];

/** Static interface copy added by feature components. AI-generated output is intentionally excluded. */
/**
 * قاموس الترجمة الحرة (Static UI Translations) المستخدم عبر tx().
 * منظّم في أقسام فرعية حسب الصفحة/المكوّن الذي تظهر فيه النصوص، لتسهيل
 * الوصول والمراجعة من لوحة إدارة الترجمة. القاموس المسطّح staticUiTranslations
 * يبقى كما هو للاستخدام في الكود (تجميع تلقائي لكل الأقسام)، وaticUiTranslationGroups
 * يربط كل نص بمعرّف الصفحة الخاصة به.
 */
// ===== عام / تحميل الصفحات (app) =====
const staticUi_app: Record<string, string> = {
  'تم حفظ الحملة بنجاح': 'Campaign saved successfully',
  'تم حذف الحملة': 'Campaign deleted',
  'تعذر إنشاء الحملة': 'Could not create the campaign',
  'تعذر خصم رصيد الحملة': 'Could not deduct the campaign credit',
  'تبقّى لك رصيد قليل من الحملات المجانية': 'You have a low balance of free campaigns left',
  'جدّد أو رقّي باقتك دلوقتي': 'Renew or upgrade your plan now',
  'حملة متبقية': 'campaigns remaining',
  'رصيدك قارب على الانتهاء': 'Your balance is running low',
  'رقّي لباقة احترافية عشان متتوقفش': 'Upgrade to a Pro plan so you don\\\'t get stuck',
  'عرض الباقات': 'View plans',
  'استهداف': 'Istihdaf',
  'محرك استهداف يعمل الآن': 'Istihdaf engine is working',
  'تحليل بيانات المشروع': 'Analyzing project data',
  'قراءة إشارات السوق': 'Reading market signals',
  'بناء شرائح الجمهور': 'Building audience segments',
  'تقدير تكلفة الليد CPL': 'Estimating CPL',
  'صياغة الاستراتيجية': 'Composing strategy',
  'تم حذف حسابك بنجاح': 'Your account was deleted successfully',
  'تم إنشاء الحساب بنجاح.': 'Account created successfully.',
  'البريد:': 'Email:',
  'كلمة المرور المؤقتة:': 'Temporary password:',
  'حدث خطأ أثناء تحديث بيانات المستخدم': 'An error occurred while updating the user.',
  'حدث خطأ أثناء إنشاء المستخدم': 'An error occurred while creating the user.',
  'حدث خطأ أثناء حذف المستخدم': 'An error occurred while deleting the user.',
  'حدث خطأ أثناء تحديث الباقة': 'An error occurred while updating the plan.',
  'حدث خطأ أثناء حفظ الحملة': 'An error occurred while saving the campaign.',
  'حدث خطأ أثناء حذف الحملة': 'An error occurred while deleting the campaign.',
  'حفظ تحديثات الحملة': 'Save campaign updates',
  'الإصدار الأول': 'First version',
  'حفظ يدوي من مساحة العمل': 'Manual save from workspace',
  'إنشاء الحملة وحفظها': 'Create and save campaign',
  'جاري تحميل مساحة الحملة...': 'Loading campaign workspace...',
  'جاري تحميل المكتبة...': 'Loading library...',
  'جاري تحميل لوحة التحكم...': 'Loading dashboard...',
};

// ===== القائمة الجانبية والشريط العلوي (nav) =====
const staticUi_nav: Record<string, string> = {
  'ذكاء الحملات متعدد المجالات': 'Multi-industry campaign intelligence',
  'التنقل الرئيسي': 'Primary navigation',
  'الأحدث': 'Recent',
  'طي القائمة الجانبية': 'Collapse sidebar',
  'فتح القائمة الجانبية': 'Expand sidebar',
};

// ===== تسجيل الدخول وإنشاء الحساب (auth) =====
const staticUi_auth: Record<string, string> = {
  'تأكيد تسجيل الدخول': 'Confirm sign-in',
  'تأكيد وتسجيل الدخول': 'Confirm and sign in',
  'تم إرسال كود تأكيد تسجيل الدخول إلى بريدك الإلكتروني': 'A sign-in confirmation code has been sent to your email',
  'كود تأكيد الدخول': 'Sign-in confirmation code',
  'مساحة عمل استهداف الذكية': 'ISTIHDAF AI WORKSPACE',
  'مرحباً بعودتك!': 'Welcome back!',
  'قم بتسجيل الدخول للوصول إلى مساحة العمل الخاصة بك.': 'Sign in to access your workspace.',
  'حملات مجانية': 'Free campaigns',
  'مصممة للعربية': 'Built for Arabic',
  'تأكيد': 'Confirm',
  'مرحباً بك من جديد يا': 'Welcome back,',
  'إعادة الإرسال بعد': 'Resend in',
  'إعادة إرسال الكود': 'Resend code',
  'ثانية': 'seconds',
  'استراتيجيات استهداف ونسخ إعلانية متعددة المجالات جاهزة خلال دقائق.': 'Multi-industry targeting strategies and ad copy, ready within minutes.',
  'منصة ذكاء اصطناعي تساعد المسوقين والوكالات وأصحاب الأنشطة على فهم الجمهور، تقدير تكلفة النتيجة، وبناء حملة أدق.': 'An AI platform that helps marketers, agencies, and business owners understand their audience, estimate cost per result, and build a more precise campaign.',
  'تحليل حسب المجال': 'Analysis by industry',
  'انضم إلينا وابدأ في بناء حملات تسويقية ذكية.': 'Join us and start building smart marketing campaigns.',
};

// ===== مولد الحملات (نموذج الإنشاء) (builder) =====
const staticUi_builder: Record<string, string> = {
  'حملة متعددة المجالات': 'Multi-industry campaign',
  'ما مجال الحملة؟': 'What is the campaign industry?',
  'مثال: باقة إدارة حسابات التواصل': 'Example: Social media management package',
  'مثال: اسم نشاطك التجاري': 'Example: Your business name',
  'مثال: كورس أونلاين، خدمة استشارية، منتج تجميلي...': 'Example: Online course, consulting service, beauty product…',
  'مثال: مصر، القاهرة والجيزة، أو دول الخليج': 'Example: Egypt, Cairo and Giza, or Gulf countries',
  'مثال: القاهرة الكبرى أو نطاق 10 كم من الفرع': 'Example: Greater Cairo or a 10 km radius around the branch',
  'اكتب ما سيحصل عليه العميل وأهم تفاصيل العرض باختصار': 'Briefly describe what the customer gets and the key offer details',
  'تفاصيل العرض أو الخصم': 'Offer or discount details',
  'مثال: خصم 20% حتى نهاية الشهر أو جلسة تعريفية مجانية': 'Example: 20% off until month-end or a free intro session',
  'مسار التحويل المطلوب': 'Desired conversion path',
  'شراء أو تسجيل من الموقع': 'Purchase or sign up on website',
  'محادثة واتساب': 'WhatsApp conversation',
  'رسائل السوشيال ميديا': 'Social media messages',
  'مكالمة هاتفية': 'Phone call',
  'زيارة الفرع': 'Store visit',
  'المشكلة التي يحلها العرض': 'Problem solved by the offer',
  'ما المشكلة أو الرغبة الأساسية لدى العميل؟': 'What is the customer’s main problem or desire?',
  'مثال: أصحاب مشروعات صغيرة في القاهرة من 25 إلى 45 سنة': 'Example: Small business owners in Cairo aged 25–45',
  'ابدأ من نموذج جاهز': 'Start from a template',
  'الحفظ التلقائي مفعّل': 'Autosave is enabled',
  'حُفظت المسودة تلقائيًا': 'Draft autosaved',
  'الخطوة': 'Step',
  'رصيد متاح': 'credits available',
  'نوع المشروع': 'Project type',
  'العملة': 'Currency',
  'المقدم %': 'Down payment %',
  'سنوات التقسيط': 'Installment years',
  'موعد التسليم': 'Delivery date',
  'إضافة': 'Add',
  'مستثمر مصري': 'Egyptian investor',
  'مصريون بالخليج': 'Egyptians in the Gulf',
  'أسرة تبحث عن سكن': 'Family seeking a home',
  'أعمال وعيادات': 'Businesses and clinics',
  'رفاهية ومصايف': 'Luxury and vacation homes',
  'أسلوب الكتابة': 'Writing style',
  'عامية مصرية': 'Egyptian Arabic',
  'عربية فصحى حديثة': 'Modern Standard Arabic',
  'مزيج احترافي': 'Professional blend',
  'الميزانية الشهرية المتوقعة': 'Expected monthly budget',
  'جاري بناء الاستراتيجية...': 'Building your strategy...',
  'إنشاء الاستراتيجية بالذكاء الاصطناعي': 'Generate strategy with AI',
  'البيانات جاهزة للتوليد': 'The data is ready for generation',
  'تمنح النسخ الإعلانية أسبابًا حقيقية للإقناع': 'Gives the ad copy concrete reasons to persuade.',
  'جودة البيانات': 'Data quality',
  'جودة بيانات الحملة': 'Campaign data quality',
  'ستُبنى الاستراتيجية على تفاصيل مكتملة.': 'The strategy will be based on complete details.',
  'ضروري لبناء الحملة وحفظها باسم واضح': 'Required to build the campaign and save it with a clear name.',
  'عرض فحص البيانات': 'View data check',
  'ما الهدف الأساسي من الحملة؟': 'What is the primary campaign goal?',
  'هدف الحملة والميزانية': 'Campaign goal and budget',
  'يحدد القناة والإجراء المطلوب من الجمهور': 'Defines the channel and desired audience action.',
  'يحسّن تقسيم الجمهور وتقدير تكلفة الليد': 'Improves audience segmentation and lead-cost estimation.',
  'يحسّن زاوية الرسالة ويقلل الافتراضات': 'Improves the message angle and reduces assumptions.',
  'يمكن تحسين دقة النتيجة': 'Result accuracy can be improved',
  'مؤشر تكلفة النتيجة للمجال': 'Cost-per-result benchmark for this industry',
  'نطاق تخطيط مبدئي لـ': 'An initial planning range for',
  'فترة التقييم المقترحة': 'Suggested evaluation period',
  'تقدير اختباري وليس ضمانًا أو بيانات حية من منصة الإعلانات.': 'An indicative estimate, not a guarantee or live data from the ad platform.',
  'اكتب طريقة التنفيذ أو التوصيل بوضوح': 'Describe how fulfillment or delivery works clearly',
  'رابط صفحة العرض أو التطبيق': 'Link to the offer page or app',
  'اكتب المواعيد أو مدة التوفر': 'Enter the schedule or availability period',
  'اذكر فقط شهادات أو ضمانات أو أدلة حقيقية يمكن إثباتها': 'Only mention certifications, guarantees, or proof points that are real and verifiable',
};

// ===== مساحة عمل الحملة والنتائج (workspace) =====
const staticUi_workspace: Record<string, string> = {
  'ركّز على العرض': 'Focus on the offer',
  'قيمة وثقة': 'Value & trust',
  'أسلوب خليجي': 'Gulf style',
  'متطلبات وسياسات المجال': 'Industry policy requirements',
  'جمهور الحملة المحدد': 'Selected campaign audience',
  'مسودة': 'Draft',
  'تكلفة الليد المتوقعة': 'Estimated lead cost',
  'تقدير مبني على المنطقة والجمهور': 'Estimate based on location and audience',
  'الميزانية اليومية': 'Daily budget',
  'نقطة بداية موصى بها': 'Recommended starting point',
  'جاهزية الحملة': 'Campaign readiness',
  'جاهزة للتنفيذ': 'Ready to launch',
  'إعادة صياغة الخطاف بالذكاء الاصطناعي': 'Rewrite the hook with AI',
  'إعادة صياغة النص الإعلاني': 'Rewrite ad copy with AI',
  'اختر شريحة لتحليلها': 'Choose a segment to analyze',
  'اسم النسخة، مثال: نسخة اعتماد العميل': 'Version name, for example: Client-approved version',
  'إطلاق اختبار مضبوط': 'Launch a controlled test',
  'اعتماد': 'Approve',
  'أُعد هذا التقرير داخل منصة استهداف': 'This report was prepared in Istihdaf',
  'أقسام ملف الحملة': 'Campaign file sections',
  'اكتب سبب القرار والبيانات أو ملاحظات العميل التي أدت إليه': 'Describe the reason, supporting data, or client feedback behind this decision.',
  'اكتب عنوان القرار وتفاصيله أولاً': 'Enter the decision title and details first.',
  'الاعتراض المتوقع': 'Expected objection',
  'الافتراضات والمخاطر': 'Assumptions and risks',
  'الأيام 10–14': 'Days 10–14',
  'الأيام 3–5': 'Days 3–5',
  'الأيام 6–9': 'Days 6–9',
  'البديل المعتمد': 'Approved alternative',
  'الجمهور الأساسي': 'Primary audience',
  'الحاجة إلى رسالة مختصرة ومباشرة': 'Needs a concise and direct message',
  'الدافع الأساسي': 'Primary motivation',
  'الرسالة': 'Message',
  'الرسالة الرئيسية': 'Primary message',
  'الرسالة المقترحة': 'Recommended message',
  'الزاوية': 'Angle',
  'السبب والتفاصيل': 'Reason and details',
  'السجل': 'History',
  'القرار التسويقي': 'Marketing decision',
  'القناة والميزانية': 'Channel and budget',
  'القنوات': 'Channels',
  'المحتوى الإعلاني': 'Ad content',
  'المقارنة تستخدم البدائل التي تم توليدها للحملة نفسها، لذلك تظل بيانات المشروع والجمهور ثابتة.': 'The comparison uses alternatives generated for the same campaign, so the project and audience data remain consistent.',
  'النسخة الإعلانية المعتمدة': 'Approved ad copy',
  'اليومان 1–2': 'Days 1–2',
  'بانتظار المراجعة': 'Awaiting review',
  'تاريخ إعداد الحملة': 'Campaign preparation date',
  'تجهيز القياس والأصول': 'Prepare tracking and assets',
  'تدفق قرار الاستهداف': 'Targeting decision flow',
  'تسجيل القرار': 'Record decision',
  'تسليم وموافقة': 'Handoff and approval',
  'تشغيل بديلين إعلانيين على شرائح الجمهور الأساسية مع ميزانية اختبار محددة.': 'Run two ad alternatives across the primary audience segments with a defined test budget.',
  'تعذر حفظ القرار': 'Could not save the decision.',
  'تعذر حفظ النسخة': 'Could not save the version.',
  'تعذر فتح نافذة التقرير. اسمح بالنوافذ المنبثقة ثم حاول مرة أخرى.': 'Could not open the report window. Allow pop-ups and try again.',
  'تعليقات العميل': 'Client comments',
  'تقدير السوق الحالي': 'Current market estimate',
  'تقدير تحليلي مبني على المنطقة والجمهور والميزانية، وليس بيانات مباشرة من منصة إعلانية.': 'An analytical estimate based on location, audience, and budget; it is not direct data from an advertising platform.',
  'تم تسجيل القرار في الحملة': 'The decision was recorded in the campaign.',
  'تم حفظ نسخة من قرارات الحملة': 'A version of the campaign decisions was saved.',
  'تم نسخ رابط المراجعة': 'Review link copied',
  'توسيع البديل الفائز': 'Scale the winning alternative',
  'جاري إنشاء الرابط...': 'Creating link...',
  'جمهور اختبار': 'Test audience',
  'جمهور ثانوي': 'Secondary audience',
  'حالة المراجعة': 'Review status',
  'حفظ الحملة': 'Save campaign',
  'حفظ نسخة': 'Save version',
  'خريطة الاستهداف': 'Targeting map',
  'خطة الاستهداف': 'Targeting plan',
  'خطة التنفيذ': 'Execution plan',
  'خطة أول 14 يومًا': 'First 14-day plan',
  'رابط مراجعة للعميل بدون تسجيل دخول': 'Client review link with no sign-in required',
  'زيادة الميزانية تدريجيًا وتحديث الرسالة بناءً على الاعتراضات الحقيقية.': 'Increase the budget gradually and update the message based on real objections.',
  'سجل القرارات': 'Decision history',
  'سجّل سبب كل تغيير مهم': 'Record the reason behind every important change',
  'سياق قابل للتتبع': 'Traceable context',
  'شرائح الجمهور': 'Audience segments',
  'عنوان القرار': 'Decision title',
  'قارن بين بديلين قبل الاعتماد': 'Compare two alternatives before approval',
  'قبل الإطلاق': 'Before launch',
  'قراءة جودة العملاء': 'Evaluate lead quality',
  'قرار': 'Decision',
  'قرار المحتوى': 'Content decision',
  'قرار مسجّل': 'recorded decisions',
  'لا توجد قرارات مسجلة بعد. ابدأ بتوثيق أول قرار مهم في الحملة.': 'No decisions have been recorded. Start by documenting the first important campaign decision.',
  'لم يضف العميل ملاحظات بعد.': 'The client has not added comments yet.',
  'مثال: اعتماد المستثمرين بالخليج كجمهور أساسي': 'Example: Approve Gulf investors as the primary audience',
  'محفوظة': 'Saved',
  'مراجعة العميل': 'Client review',
  'مراجعة تكلفة الليد وجودة المحادثات وإيقاف الشرائح غير المناسبة.': 'Review lead cost and conversation quality, then stop unsuitable segments.',
  'مراجعة صفحة الهبوط، الأحداث، رقم واتساب، والنسخ الإعلانية المعتمدة.': 'Review the landing page, events, WhatsApp number, and approved ad copies.',
  'مرجع الحملة': 'Campaign reference',
  'مطلوب تعديل': 'Changes required',
  'معتمدة': 'Approved',
  'مقارنة البدائل': 'Compare alternatives',
  'ملاحظة': 'comment',
  'ملف الحملة': 'Campaign file',
  'ملف عمل الحملة': 'Campaign workspace',
  'نسخ رابط المراجعة': 'Copy review link',
  'نسخة العميل': 'Client version',
  'نسخة داخلية': 'Internal version',
  'نطاق CPL تقدير تحليلي ويجب التحقق منه بعد أول ثلاثة أيام من التشغيل.': 'The CPL range is an analytical estimate and should be validated after the first three days of delivery.',
  'نوع القرار': 'Decision type',
  'هدف الحملة': 'Campaign goal',
  'يرى العميل النسخة المخصصة له فقط، ويمكنه الموافقة أو طلب تعديل وإضافة ملاحظات محفوظة على الحملة.': 'The client sees only the client-facing version and can approve, request changes, or add comments saved to the campaign.',
  'المحاكي': 'Simulator',
  'تحديث محاكاة الحملة': 'Campaign simulation update',
  'تعديل افتراضات الميزانية والنتائج المتوقعة': 'Updated budget and outcome assumptions',
  'تحديث حزمة الإطلاق': 'Launch package update',
  'تحديث محتويات الحزمة أو قائمة الفحص': 'Updated the package contents or checklist',
  'الإصدارات': 'Versions',
  'إنشاء مسودة بوابة الاعتماد': 'Create approval portal draft',
  'تم إنشاء مسودة بوابة الاعتماد': 'Approval portal draft created.',
  'إرسال للمراجعة ونسخ الرابط': 'Send for review & copy link',
  'تم إرسال الحملة للمراجعة ونسخ الرابط': 'The campaign was sent for review and its link was copied.',
  'تصدير النسخة المعتمدة PDF': 'Export approved PDF',
  'سجل التعديلات والاعتماد': 'Change & approval history',
  'محرر النصوص': 'Text editor',
  'تعديل يدوي للنصوص': 'Manual text editing',
  'تعديل النصوص المولّدة والاستهداف من محرر الحملة': 'Edit the generated copy and targeting from the campaign editor',
  'تم حفظ تعديلات النصوص كإصدار جديد بدون خصم رصيد': 'Text edits saved as a new version without using credits',
};

// ===== محرر النصوص المولّدة (editor) =====
const staticUi_editor: Record<string, string> = {
  'نوع المنتج أو الخدمة': 'Product or service type',
  'الفئة العمرية': 'Age group',
  'المنطقة الفرعية': 'Sub-area',
  'الجمهور المستهدف': 'Target audience',
  'الدعوة للإجراء': 'Call to action',
  'حزمة الإطلاق': 'Launch package',
  'تحرير كامل بدون خصم رصيد': 'Full editing without using credits',
  'محرر النصوص المولّدة': 'Generated copy editor',
  'عدّل النصوص والاستهداف وحزمة الإطلاق، ثم احفظها كإصدار جديد. أي اعتماد سابق يُلغى تلقائيًا بعد التعديل لحماية النشر.': 'Edit the copy, targeting, and launch package, then save it as a new version. Any prior approval is automatically cleared after editing to protect publishing.',
  'التراجع عن التعديلات': 'Undo changes',
  'جاري حفظ التعديلات...': 'Saving changes...',
  'تم الحفظ': 'Saved',
  'حفظ التعديلات': 'Save changes',
  'ملخص العرض': 'Offer summary',
  'اسم المشروع أو العرض': 'Project or offer name',
  'اسم المطور أو العلامة': 'Developer or brand name',
  'المنطقة الأساسية': 'Primary region',
  'مشكلة العميل التي يحلها العرض': 'The customer problem this offer solves',
  'تفاصيل العرض أو الترويج': 'Offer or promotion details',
  'تفاصيل التنفيذ أو التوصيل': 'Fulfillment or delivery details',
  'عناصر الثقة': 'Trust signals',
  'الجدول أو موعد البدء': 'Schedule or start date',
  'رابط صفحة العرض': 'Offer page link',
  'المميزات — سطر لكل ميزة': 'Features — one per line',
  'الاستهداف وإعداد الحملة': 'Targeting & campaign setup',
  'الموقع والجمهور': 'Location & audience',
  'المناطق — سطر لكل منطقة': 'Regions — one per line',
  'النطاق أو نقاط الاستهداف': 'Radius or targeting points',
  'وصف الاستهداف الجغرافي': 'Geographic targeting description',
  'النوع': 'Type',
  'الحالة الاجتماعية': 'Marital status',
  'الشريحة الشرائية أو الدخل': 'Buying segment or income level',
  'الاهتمامات المولّدة': 'Generated interests',
  'مجموعة اهتمام': 'Interest group',
  'اسم المجموعة': 'Group name',
  'كلمات Meta بالإنجليزية — سطر لكل كلمة': 'Meta interest terms in English — one per line',
  'شرح سبب الاختيار': 'Reason for this choice',
  'السلوكيات والاستبعادات': 'Behaviors & exclusions',
  'السلوكيات بالإنجليزية — سطر لكل سلوك': 'Behaviors in English — one per line',
  'شرح السلوكيات': 'Explanation of behaviors',
  'الاستبعادات بالإنجليزية — سطر لكل استبعاد': 'Exclusions in English — one per line',
  'سبب الاستبعاد': 'Reason for exclusion',
  'إعدادات الحملة': 'Campaign settings',
  'هدف منصة الإعلانات': 'Ad platform objective',
  'الميزانية اليومية المقترحة': 'Suggested daily budget',
  'نطاق تكلفة النتيجة': 'Cost-per-result range',
  'أماكن الظهور — سطر لكل مكان': 'Placements — one per line',
  'تنبيه الفئة الإعلانية الخاصة': 'Special ad category notice',
  'النسخ الإعلانية': 'Ad copy',
  'البديل الإعلاني': 'Ad variant',
  'اسم الزاوية': 'Angle name',
  'وصف الزاوية': 'Angle description',
  'الخطاف': 'Hook',
  'العنوان الإعلاني': 'Ad headline',
  'الوصف القصير': 'Short description',
  'فكرة التصميم': 'Creative idea',
  'النقاط البارزة — سطر لكل نقطة': 'Highlights — one per line',
  'استراتيجية الجمهور — سطر لكل عنصر': 'Audience strategy — one point per line',
  'الخطافات — سطر لكل خطاف': 'Hooks — one per line',
  'أفكار التصميم — سطر لكل فكرة': 'Creative ideas — one per line',
  'أفكار الفيديو — سطر لكل فكرة': 'Video ideas — one per line',
  'القناة': 'Channel',
  'الغرض': 'Purpose',
  'النسبة': 'Ratio',
  'روابط القياس وقائمة الفحص': 'Tracking links & checklist',
  'اسم الرابط': 'Link name',
  'لديك تعديلات غير محفوظة': 'You have unsaved changes',
  'كل التعديلات محفوظة': 'All changes saved',
  'حفظ التعديلات كإصدار جديد': 'Save changes as a new version',
};

// ===== إصدارات الحملة (versions) =====
const staticUi_versions: Record<string, string> = {
  'الزاوية الإعلانية': 'Ad angle',
  'العنصر': 'Item',
  'الميزانية': 'Budget',
  'الخطاف الإعلاني': 'Ad hook',
  'تاريخ قابل للاستعادة': 'Restorable history',
  'إصدارات الحملة والمقارنة': 'Campaign versions & comparison',
  'كل حفظ فعلي ينشئ نقطة زمنية توضح من عدّل ومتى، ويمكنك إنشاء فروع A/B أو استعادة أي نسخة.': 'Every actual save creates a timestamped revision with its editor. You can branch A/B variants or restore any version.',
  'اسم الإصدار أو الاختبار': 'Version or test name',
  'إصدار رئيسي': 'Main version',
  'إنشاء الإصدار': 'Create version',
  'نسخة محفوظة يدويًا': 'Manually saved version',
  'إنشاء نسخة اختبار A/B': 'Create A/B test variant',
  'تم إنشاء إصدار جديد للحملة': 'A new campaign version was created',
  'استعادة': 'Restore',
  'استعادة إصدار سابق': 'Restored a previous version',
  'تمت استعادة الإصدار وإنشاء نقطة رجوع جديدة': 'The version was restored and a new rollback point was created.',
  'استعادة هذا الإصدار': 'Restore this version',
  'عدد القرارات': 'Decision count',
  'نتائج الإصدار بعد التشغيل': 'Post-launch version results',
  'حفظ النتائج': 'Save results',
  'تم حفظ نتائج الإصدار': 'Version results saved',
  'أنشئ إصدارين على الأقل لعرض المقارنة.': 'Create at least two versions to compare them.',
  'جاري تحميل الإصدارات...': 'Loading versions…',
  'تم استيراد النتائج من CSV — راجعها ثم اضغط حفظ النتائج': 'Results imported from CSV — review them, then click Save Results',
  'مرّ أكتر من أسبوعين — أدخل نتائج حملتك الفعلية لقياس دقة توقعاتنا': 'It\'s been over two weeks — enter your campaign\'s actual results to help us measure forecast accuracy',
  'استيراد CSV': 'Import CSV',
  'نموذج CSV': 'CSV template',
  'توصية تلقائية': 'Automatic recommendation',
};

// ===== مكتبة المحتوى (library) =====
const staticUi_library: Record<string, string> = {
  'اكتب عنوانًا ومحتوى قبل الحفظ': 'Write a title and content before saving',
  'تمت إضافة المحتوى إلى المكتبة': 'Content added to the library',
  'تم استيراد نصوص الحملة إلى المكتبة': 'Campaign copy imported to the library',
  'تم حذف عنصر المحتوى': 'Content item deleted',
  'أصول إبداعية قابلة لإعادة الاستخدام': 'Reusable creative assets',
  'مكتبة النصوص والزوايا': 'Copy & angles library',
  'احفظ أفضل الخطافات والنصوص والدعوات للإجراء، ثم ابحث عنها واستخدمها في حملاتك القادمة.': 'Save your best hooks, copy, and calls to action, then find and reuse them in future campaigns.',
  'إضافة سريعة': 'Quick add',
  'احفظ فكرة أو نصًا جديدًا': 'Save a new idea or piece of copy',
  'عنوان واضح للمحتوى': 'A clear title for the content',
  'عام لكل المجالات': 'General, for all industries',
  'اكتب الخطاف أو النص أو الفكرة هنا...': 'Write the hook, copy, or idea here...',
  'إضافة إلى المكتبة': 'Add to library',
  'استيراد': 'Import',
  'استيراد من حملة محفوظة': 'Import from a saved campaign',
  'يتم حفظ الخطافات ونصوص الإعلانات كعناصر منفصلة قابلة للبحث.': 'Hooks and ad copy are saved as separate, searchable items.',
  'ابحث في المكتبة...': 'Search the library...',
  'لا يوجد محتوى مطابق بعد.': 'No matching content yet.',
  'تم نسخ المحتوى': 'Content copied',
};

// ===== الحملات المحفوظة (saved) =====
const staticUi_saved: Record<string, string> = {
  'لم تنشئ أي حملة بعد': 'No campaigns yet',
  'مكتبة الحملات': 'Campaign library',
  'راجع حملاتك في كل المجالات، وقارن الاستراتيجيات، وواصل العمل من حيث توقفت.': 'Review campaigns across industries, compare strategies, and continue where you left off.',
  'حملة محفوظة': 'Saved campaign',
  'ابدأ بإضافة حملتك الأولى ودع استهداف يبني لك استراتيجية التسويق.': 'Add your first campaign and let Istihdaf build your marketing strategy.',
  'مسح البحث': 'Clear search',
  'نتيجة': 'results',
  'حذف المشروع؟': 'Delete project?',
  'سيتم حذف': 'This will permanently delete',
  'نهائيًا من مشاريعك المحفوظة. لا يمكن التراجع عن هذا الإجراء.': 'from your saved projects. This action cannot be undone.',
  'حذف المشروع': 'Delete project',
};

// ===== استراتيجيات CPL (insights) =====
const staticUi_insights: Record<string, string> = {
  'متوسط السعر/م²': 'Average price/m²',
  'النمو السنوي': 'Annual growth',
  '/م²': '/m²',
  'مرصد السوق العقاري': 'Real Estate Market Observatory',
  'تقرير يومي مولّد بالذكاء الاصطناعي لاتجاهات الطلب والأسعار وتكاليف الحملات والمنافسة.': 'A daily AI-generated report on demand, pricing, campaign costs, and competition.',
  'ملخص المرصد': 'Observatory summary',
  'إشارات الطلب': 'Demand signals',
  'المناطق الصاعدة': 'Rising areas',
  'سلوك المشترين': 'Buyer behavior',
  'أكثر أنواع الوحدات طلبًا': 'Most in-demand unit types',
  'المنافسة': 'Competition',
  'المطورون والمشروعات المنافسة': 'Competing developers & projects',
  'أكثر الزوايا الإعلانية استخدامًا': 'Most-used advertising angles',
  'مقارنة مخصصة': 'Custom comparison',
  'مقارنة المشروع بالسوق': 'Compare project with market',
  'منطقة المشروع': 'Project region',
  'سعر البداية': 'Starting price',
  'متوسط CPL في السوق': 'Market average CPL',
  'لا يوجد تطابق مباشر؛ راجع أقرب منطقة في البنشمارك.': 'No direct match. Review the closest benchmark region.',
  'التوصية': 'Recommendation',
  'ابدأ بميزانية اختبار ثم حدّث المقارنة بعد أول 72 ساعة.': 'Start with a test budget, then update the comparison after 72 hours.',
  'احفظ مشروعًا أولاً لعرض مقارنة مخصصة بالسوق.': 'Save a project to compare it with the market.',
};

// ===== شات الذكاء الاصطناعي (chat) =====
const staticUi_chat: Record<string, string> = {
  'من هو الجمهور الأنسب لهذا العرض؟': 'Who is the best audience for this offer?',
  'خبيرك في بناء الحملات متعددة المجالات وتحليل الجمهور والعروض': 'Your expert in multi-industry campaigns, audience analysis, and offers',
  'ذكاء تسويقي متعدد المجالات': 'Multi-industry marketing intelligence',
  'اقترح لي أفضل Hook إعلاني': 'Suggest the best advertising hook',
  'ما الميزانية اليومية المناسبة؟': 'What is the right daily budget?',
  'هل أستخدم WhatsApp أم Lead Form؟': 'Should I use WhatsApp or a lead form?',
  'مساعد استهداف الذكي': 'Istihdaf AI Assistant',
  'جاهز للمساعدة': 'Ready to help',
  'جاري تحميل المحادثة': 'Loading conversation',
  'ما الذي تريد تحليله اليوم؟': 'What would you like to analyze today?',
  'اسأل عن مشروعك أو جمهورك أو ميزانيتك، وسأحوّل سؤالك إلى توصيات عملية قابلة للتنفيذ.': 'Ask about your project, audience, or budget, and I will turn your question into actionable recommendations.',
  'بناء الجمهور': 'Audience building',
  'فكرة إعلانية': 'Ad concept',
  'تخطيط الميزانية': 'Budget planning',
  'اختيار القناة': 'Channel selection',
  'بيانات محادثتك تبقى داخل حسابك': 'Your conversation data stays in your account',
  'أنت': 'You',
  'مساعد استهداف': 'Istihdaf Assistant',
  'نسخ الإجابة': 'Copy answer',
  'تم نسخ الإجابة': 'Answer copied',
  'تعذّر نسخ الإجابة': 'Could not copy the answer',
  'صورة مرفقة': 'Attached image',
  'جاري إعداد الإجابة': 'Preparing answer',
  'معاينة الصورة المرفقة': 'Attached image preview',
  'صورة جاهزة للتحليل': 'Image ready for analysis',
  'ستُرسل مع رسالتك التالية': 'It will be sent with your next message',
  'إزالة الصورة': 'Remove image',
  'إرسال الرسالة': 'Send message',
  'Enter للإرسال · Shift + Enter لسطر جديد': 'Enter to send · Shift + Enter for a new line',
};

// ===== مساحة الفريق (team) =====
const staticUi_team: Record<string, string> = {
  'نشط': 'Active',
  'ميزة باقة الوكالات': 'Agency plan feature',
  'مساحات فرق العمل': 'Team workspaces',
  'أدر فريقك وصلاحياته وإسناد الحملات والتعليقات الداخلية من مكان واحد.': 'Manage team permissions, campaign assignments, and internal comments in one place.',
  'الترقية إلى باقة الوكالات': 'Upgrade to Agency',
  'جاري تحميل مساحة الفريق...': 'Loading team workspace…',
  'باقة الوكالات': 'Agency plan',
  'إدارة واضحة للأدوار، الحملات، والاستخدام داخل فريق واحد.': 'Clear control of roles, campaigns, and usage in one team.',
  'أعضاء': 'members',
  'الأعضاء والصلاحيات': 'Members & permissions',
  'فريق العمل': 'Team',
  'العضو': 'Member',
  'الدور': 'Role',
  'الاستخدام': 'Usage',
  'تمت دعوته': 'Invited',
  'دعوة عضو جديد': 'Invite a new member',
  'اسم العضو': 'Member name',
  'حد الاستخدام': 'Usage limit',
  'إرسال الدعوة': 'Send invite',
  'إسناد حملة': 'Assign campaign',
  'اختر المسؤول': 'Select owner',
  'تأكيد الإسناد': 'Confirm assignment',
  'احفظ حملة أولاً لتتمكن من إسنادها.': 'Save a campaign before assigning it.',
  'تعليق داخلي': 'Internal comment',
  'ملاحظة لا تظهر للعميل': 'A note hidden from the client',
  'حفظ التعليق': 'Save comment',
  'لا يوجد نشاط مسجل بعد.': 'No activity has been recorded yet.',
  'تم إسناد الحملة': 'Campaign assigned.',
  'تم حفظ التعليق الداخلي': 'Internal comment saved.',
  'إعادة إرسال الدعوة': 'Resend invite',
  'حذف العضو': 'Remove member',
  'تم إعادة إرسال الدعوة': 'Invite resent.',
  'تم حذف العضو من الفريق': 'Member removed from the team.',
  'تم تحديث صلاحيات العضو': 'Member\'s permissions updated',
  'تعديل الدور والصلاحيات': 'Edit role and permissions',
  'حد الاستخدام الشهري': 'Monthly usage limit',
  'تخصيص صلاحيات هذا العضو يدويًا (بدل صلاحيات الدور الافتراضية)': 'Customize this member\'s permissions manually (instead of the default role permissions)',
};

// ===== سجل الرصيد (credits) =====
const staticUi_credits: Record<string, string> = {
  'سجل استخدام الرصيد': 'Credit usage log',
  'كل خصم أو استرجاع مع الرصيد قبل العملية وبعدها': 'Every deduction or refund, with the balance before and after',
  'تحديث سجل الرصيد': 'Refresh credit log',
  'جاري تحميل سجل الرصيد...': 'Loading credit log...',
  'لا توجد عمليات رصيد مسجلة بعد.': 'No credit transactions recorded yet.',
  'الكريدات والفترة التجريبية': 'Credits and free trial',
  'الكريدات والفترات التجريبية': 'Credits and free trials',
  'بيانات باقتك واستهلاكك محدثة مباشرة من الخادم': 'Your plan and usage data are updated directly from the server',
  'الباقة الحالية': 'Current plan',
  'إجمالي الكريدات': 'Total credits',
  'الكريدات المستخدمة': 'Credits used',
  'الكريدات المتبقية': 'Credits remaining',
  'موعد تجديد الكريدات': 'Credit renewal date',
  'متبقي': 'remaining',
  'الفترة التجريبية المجانية': 'Free trial',
  'بدء الفترة التجريبية': 'Start free trial',
  'تم بدء الفترة التجريبية بنجاح': 'Your free trial has started successfully',
  'تعذر بدء الفترة التجريبية': 'Could not start the free trial',
  'تعذر جلب بيانات الرصيد والفترة التجريبية': 'Could not load credit and trial data',
  'جاري تحميل بيانات الرصيد...': 'Loading credit data...',
  'تحديث البيانات': 'Refresh data',
  'غير مستخدمة': 'Not used',
  'متاحة للتفعيل': 'Available to activate',
  'مفعلة حالياً': 'Currently active',
  'منتهية': 'Expired',
  'ملغاة': 'Cancelled',
  'الأيام المتبقية': 'Days remaining',
  'تاريخ البداية': 'Start date',
  'تاريخ انتهاء التجربة': 'Trial end date',
  'استخدم جميع مميزات Pro لمدة': 'Use all Pro features for',
  'يوم، ولن يبدأ العد إلا عند الضغط على الزر.': 'days; the countdown starts only when you press the button.',
  'لديك فترة تجريبية مجانية متاحة ويمكنك تشغيلها الآن.': 'You have a free trial available to activate now.',
  'تنتهي فترتك التجريبية خلال': 'Your free trial ends in',
  'رصيدك منخفض وقارب على الانتهاء.': 'Your credit balance is low and close to running out.',
  'انتهى رصيد الكريدات. اشحن أو جدّد باقتك للمتابعة.': 'Your credits have run out. Top up or renew your plan to continue.',
  'إعدادات التجربة واستهلاك الكريدات': 'Trial and credit usage settings',
  'تطبق هذه القواعد من الخادم على جميع الحسابات': 'These server-side rules apply to all accounts',
  'نظام الفترة التجريبية': 'Free trial system',
  'نسبة تنبيه انخفاض الرصيد': 'Low-balance alert percentage',
  'طريقة تكلفة الشات': 'Chat billing method',
  'لكل رسالة': 'Per message',
  'حزمة رسائل': 'Message bundle',
  'عدد الرسائل في الحزمة': 'Messages per bundle',
  'كريدات الحزمة': 'Credits per bundle',
  'مفعّل': 'Enabled',
  'متوقف': 'Disabled',
  'حفظ الإعدادات': 'Save settings',
  'تم حفظ إعدادات الكريدات': 'Credit settings saved',
  'إدارة استهلاك الكريدات': 'Credit consumption management',
  'تكلفة مستقلة لكل أداة، بما فيها Agency': 'A separate cost for every tool, including Agency',
  'الاسم بالعربية': 'Arabic name',
  'الاسم بالإنجليزية': 'English name',
  'التكلفة': 'Cost',
  'مفتاح الأداة الجديدة': 'New tool key',
  'تم تحديث تكلفة العملية': 'Operation cost updated',
  'تمت إضافة الأداة الجديدة': 'New tool added',
  'إدارة الفترات التجريبية': 'Free trial management',
  'منح حساب أو مجموعة أو جميع الحسابات مع مدة مستقلة': 'Grant one, multiple, or all accounts with individual durations',
  'منح للمحدد': 'Grant selected',
  'منح للجميع': 'Grant all',
  'اختر حساباً واحداً على الأقل': 'Select at least one account',
  'تم منح الفترة التجريبية للحسابات المحددة': 'Free trial granted to selected accounts',
  'تم منح الفترة التجريبية لجميع الحسابات': 'Free trial granted to all accounts',
  'تم منح فترة تجريبية جديدة': 'A new free trial was granted',
  'تم إلغاء الفترة التجريبية': 'Free trial cancelled',
  'بحث بالاسم أو البريد': 'Search by name or email',
  'الباقة / الرصيد': 'Plan / balance',
  'حالة التجربة': 'Trial status',
  'البداية / النهاية': 'Start / end',
  'المدة': 'Duration',
  'إعادة منح': 'Grant again',
  'منح': 'Grant',
  '3 أشهر': '3 months',
  'أيام': 'days',
  'التحكم اليدوي في كريدات المستخدمين': 'Manual user credit control',
  'كل تعديل يتطلب سبباً ويُسجل تلقائياً': 'Every adjustment requires a reason and is logged automatically',
  'اختر مستخدماً': 'Select a user',
  'نوع التعديل': 'Adjustment type',
  'تحديد الرصيد': 'Set balance',
  'العدد': 'Amount',
  'سبب التعديل': 'Adjustment reason',
  'تنفيذ': 'Apply',
  'تم تعديل الرصيد وتسجيل العملية': 'Balance adjusted and transaction recorded',
  'سجل حركة الكريدات': 'Credit transaction log',
  'آخر 200 عملية إضافة أو خصم لجميع المستخدمين': 'The latest 200 credit additions or deductions across all users',
  'نوع العملية': 'Operation type',
  'التغيير': 'Change',
  'الرصيد قبل / بعد': 'Balance before / after',
  'السبب': 'Reason',
  'التاريخ والوقت': 'Date and time',
  'جاري تحميل نظام الكريدات...': 'Loading credit system...',
  'تعذر جلب إعدادات الكريدات': 'Could not load credit settings',
  'تعذر حفظ التغييرات': 'Could not save changes',
  'كريدت': 'credit',
  'غير محدد': 'Not specified',
  'إنشاء استراتيجية حملة': 'Generate campaign strategy',
  'إنشاء حملة بديلة': 'Generate fallback campaign',
  'إنشاء سيناريو فيديو': 'Generate video script',
  'تحليل السوق': 'Market analysis',
  'إعادة إنشاء جزء من الاستراتيجية': 'Regenerate strategy section',
  'إعادة صياغة المحتوى': 'Rewrite content',
  'تحليل المنافسين': 'Competitor analysis',
  'إنشاء محتوى متعدد المنصات': 'Generate multi-platform content',
  'رسالة في الشات': 'Chat message',
  'رصيد التسجيل المجاني': 'Free signup credits',
  'رصيد تجديد الباقة': 'Plan renewal credits',
  'تعديل الرصيد بواسطة الإدارة': 'Admin credit adjustment',
  'انتهاء الباقة': 'Plan expiry',
  'استرجاع رصيد بعد فشل تقني': 'Credit refund after a technical failure',
  'تم تجديد الكريدات': 'Credits renewed',
  'انتهاء الفترة التجريبية': 'Free trial expired',
  'إلغاء الفترة التجريبية': 'Free trial cancelled',
  'تعديل مع سبب': 'Adjust with a reason',
  'رصيد محدد وقابل للتعديل': 'Finite, configurable credits',
  'سيتم خصم التكلفة المحددة للعملية': 'The configured operation cost will be deducted',
  'خصم حسب تكلفة العملية': 'Deduct configured operation cost',
  'تُخصم تكلفة العملية المحددة من الإدارة، وتُعاد تلقائيًا إذا فشل التوليد تقنيًا.': 'The admin-configured operation cost is deducted and automatically refunded if generation fails technically.',
  'إعادة صياغة متقدمة برصيد مرن': 'Advanced rewriting with flexible credits',
  'رصيد Agency موسّع وقابل للإدارة': 'Expanded, manageable Agency credits',
  'استهلاك كريدات الشات': 'Chat credit consumption',
  'تم نقل إعدادات تكلفة الرسائل والحزم إلى نظام الكريدات الموحد.': 'Message and bundle billing settings have moved to the unified credit system.',
  'فتح إعدادات الكريدات': 'Open credit settings',
  'لا يوجد رصيد كافٍ لإتمام هذه العملية': 'You do not have enough credits for this operation',
  'لا يوجد رصيد كافٍ لإرسال الرسالة': 'You do not have enough credits to send this message',
  'نظام الفترة التجريبية متوقف حالياً': 'The free trial system is currently disabled',
  'الفترة التجريبية مفعلة بالفعل': 'The free trial is already active',
  'لا توجد فترة تجريبية متاحة لهذا الحساب': 'No free trial is available for this account',
  'فتح الحساب': 'Open account',
  'الإجراءات': 'Actions',
  'اختر حساباً واحداً على الأقل ومدة صالحة': 'Select at least one account and a valid duration',
  'تعذر إلغاء الفترة التجريبية': 'Could not cancel the free trial',
  'تعذر تحديث تكلفة العملية': 'Could not update the operation cost',
  'تعذر تعديل رصيد المستخدم': 'Could not adjust the user balance',
  'تعذر حفظ إعدادات الكريدات': 'Could not save credit settings',
  'تعذر منح الفترة التجريبية': 'Could not grant the free trial',
  'تكلفة العملية غير صالحة': 'The operation cost is invalid',
  'مدة التجربة غير صالحة': 'The trial duration is invalid',
  'مفتاح العملية غير صالح': 'The operation key is invalid',
  'نوع التعديل والعدد والسبب مطلوبة': 'Adjustment type, amount, and reason are required',
  'مركز الإشعارات': 'Notification center',
  'تحديد الكل كمقروء': 'Mark all as read',
  'لا توجد إشعارات حالياً': 'No notifications right now',
  'متجر الكريدات': 'Credit store',
  'اشترِ كريدات إضافية دون تغيير باقتك': 'Buy extra credits without changing your plan',
  'صالحة لمدة': 'Valid for',
  'طلب الحزمة': 'Order pack',
  'تم إنشاء طلب الشحن. حوّل المبلغ باستخدام البيانات الظاهرة.': 'Top-up order created. Transfer the amount using the displayed details.',
  'بيانات التحويل': 'Transfer details',
  'المبلغ': 'Amount',
  'المرجع': 'Reference',
  'إنستاباي': 'Instapay',
  'المحفظة': 'Wallet',
  'كود ترويجي للكريدات أو التجربة': 'Promotion code for credits or a trial',
  'تطبيق': 'Apply',
  'تم تطبيق الكود الترويجي': 'Promotion code applied',
  'تكلفة الأدوات قبل التنفيذ': 'Tool costs before running',
  'آخر طلب': 'Latest order',
  'حزم الكريدات وطلبات الشحن': 'Credit packs and top-up orders',
  'اسم عربي': 'Arabic name',
  'اسم إنجليزي': 'English name',
  'السعر بالقروش': 'Price in piastres',
  'إنشاء حزمة': 'Create pack',
  'تم إنشاء حزمة الكريدات': 'Credit pack created',
  'تم إيقاف الحزمة': 'Pack disabled',
  'تم تفعيل الحزمة': 'Pack enabled',
  'إيقاف': 'Disable',
  'تفعيل': 'Enable',
  'اعتماد': 'Approve',
  'رفض': 'Reject',
  'تم اعتماد طلب الشحن': 'Top-up order approved',
  'تم رفض الطلب': 'Order rejected',
  'أكواد المكافآت': 'Reward codes',
  'فترة تجريبية': 'Free trial',
  'أقصى استخدام': 'Maximum redemptions',
  'إنشاء كود': 'Create code',
  'تم إنشاء الكود الترويجي': 'Promotion code created',
  'تم تحديث الكود': 'Promotion code updated',
  'استخدام': 'redemptions',
  'استهداف تجربة مجانية حسب الشريحة': 'Target free trials by segment',
  'مستخدمو المجانية': 'Free-plan users',
  'غير النشطين 30 يوماً': 'Inactive for 30 days',
  'بلا حملات': 'No campaigns',
  'رصيدهم منتهٍ': 'No credits left',
  'المستخدمون الجدد': 'New users',
  'لم يستخدموا التجربة': 'Trial not used',
  'منح للشريحة': 'Grant to segment',
  'تم منح التجربة للشريحة المستهدفة': 'Trial granted to the target segment',
  'التحليلات والتقارير': 'Analytics and reports',
  'تصدير CSV': 'Export CSV',
  'المستهلك خلال 30 يوماً': 'Consumed in 30 days',
  'المضاف خلال 30 يوماً': 'Added in 30 days',
  'مستخدمون نشطون': 'Active users',
  'مراقبة سلامة الرصيد': 'Credit integrity monitoring',
  'حالات عدم التطابق المفتوحة': 'Open mismatches',
  'مهام فاشلة خلال أسبوع': 'Failed jobs this week',
  'تشغيل دورة الحياة': 'Run lifecycle job',
  'تشغيل المطابقة': 'Run reconciliation',
  'تم تشغيل مهمة دورة الحياة': 'Lifecycle job completed',
  'تم تشغيل المطابقة': 'Reconciliation completed',
  'إنشاء وحذف الباقات': 'Create and delete plans',
  'مفتاح الباقة': 'Plan key',
  'المدة بالأيام': 'Duration in days',
  'ميزة في كل سطر': 'One feature per line',
  'إنشاء باقة': 'Create plan',
  'تم إنشاء الباقة': 'Plan created',
  'هل تريد حذف هذه الباقة؟': 'Do you want to delete this plan?',
  'تم حذف الباقة': 'Plan deleted',
  'حد الاستخدام اليومي': 'Daily usage limit',
  'شهري': 'Monthly',
  'يومي': 'Daily',
  'قواعد الحساب الأساسية': 'Basic calculation rules',
  'الرصيد والباقات': 'Credits and plans',
  'كل عملية تخصم عددًا صحيحًا مباشرًا من رصيد المستخدم.': 'Each operation deducts a direct whole number from the user balance.',
  'تأكيد العمليات من تكلفة': 'Confirm operations costing',
  'حساب استهلاك المحادثة': 'Chat usage calculation',
  'اختر الخصم العادي لكل رسالة أو خصم حزمة كاملة.': 'Choose normal per-message deduction or a full message bundle.',
  'خصم عادي لكل رسالة': 'Normal deduction per message',
  'مثال الحساب': 'Calculation example',
  'الرصيد الحالي − تكلفة العملية = الرصيد الجديد': 'Current balance − operation cost = new balance',
  'تكلفة العملية': 'Operation cost',
  'كريدت لكل عملية': 'credits per operation',
};

// ===== الدفع اليدوي (payment) =====
const staticUi_payment: Record<string, string> = {
  'إغلاق': 'Close',
  'إتمام الاشتراك بالتحويل': 'Complete your subscription by transfer',
  'المبلغ المطلوب تحويله': 'Amount to transfer',
  'اذكر هذا الرقم المرجعي في التحويل': 'Mention this reference number in the transfer',
  'التحويل عبر إنستاباي (Instapay)': 'Transfer via Instapay',
  'التحويل عبر المحفظة الإلكترونية': 'Transfer via e-wallet',
  'وسائل الدفع غير مهيأة حالياً، من فضلك تواصل مع الدعم الفني': 'Payment methods are not configured yet, please contact support',
  'بعد التحويل، ابعت لقطة شاشة لإثبات الدفع مع الرقم المرجعي عن طريق الشات المباشر (زر الدعم الفني أسفل الشاشة). هيتم تفعيل باقتك خلال وقت قصير من مراجعة التحويل.': 'After transferring, send a screenshot of the payment proof with the reference number via live chat (support button at the bottom of the screen). Your plan will be activated shortly after we review the transfer.',
  'تم النسخ ✓': 'Copied ✓',
  'تعذر تسجيل طلب الدفع، حاول مجدداً': 'Couldn\'t submit the payment request, please try again',
  'جاري التسجيل...': 'Submitting...',
  'تم، سأرسل إثبات التحويل': 'Done, I\'ll send the transfer proof',
};

// ===== الباقات والأسعار (pricing) =====
const staticUi_pricing: Record<string, string> = {
  'تم تطبيق كود الخصم': 'Discount code applied',
  'خصم': 'Discount',
  'لديك كود خصم؟ اكتبه هنا (اختياري)': 'Have a discount code? Enter it here (optional)',
  'الاشتراك يتم عن طريق التحويل المباشر — إنستاباي أو محفظة إلكترونية': 'Subscribe via direct transfer — Instapay or e-wallet',
  'جاري الاتصال...': 'Connecting...',
  'اطلب تفاصيل التحويل': 'Get transfer details',
  'تحويل آمن ومباشر': 'Secure direct transfer',
  'تعذر إنشاء طلب الدفع': 'Could not create the payment request',
  'تم إنشاء طلب الدفع. سيتم تفعيل باقتك فور مراجعة التحويل من فريقنا.': 'Your payment request has been created. Your plan will be activated once our team reviews the transfer.',
  'ج.م': 'EGP',
  'الباقة الاحترافية Pro': 'Pro plan',
  'باقة الوكالات Agency': 'Agency plan',
  'شهر': 'month',
  'حدث خطأ، يرجى المحاولة مجدداً': 'Something went wrong. Please try again.',
  'مجاني دائماً': 'Free forever',
  'غير متاح استرداد الأموال': 'Refunds are unavailable',
  'دفع مشفر SSL': 'SSL-encrypted payment',
  'دعم فني 24/7': '24/7 support',
};

// ===== إعدادات العلامة التجارية (brand) =====
const staticUi_brand: Record<string, string> = {
  'اسم العميل الحالي': 'Current client name',
  'اسم الوكالة': 'Agency name',
  'أضف أسلوب وكالتك وبيانات العميل لتطبيقها تلقائيًا': 'Add your agency style and client details to apply them automatically.',
  'افصل الكلمات بفاصلة': 'Separate words with commas',
  'الدعوة المفضلة للإجراء': 'Preferred call to action',
  'بيانات التواصل': 'Contact details',
  'تُحفظ هذه الإعدادات في حسابك وتُرفق بالحملات والتقارير وروابط مراجعة العملاء.': 'These settings are saved to your account and attached to campaigns, reports, and client review links.',
  'تم حفظ هوية الوكالة وتطبيقها على الحملات الجديدة': 'The agency identity was saved and will be applied to new campaigns.',
  'حفظ هوية الوكالة': 'Save agency identity',
  'ذاكرة الهوية': 'Brand memory',
  'رقم الهاتف أو واتساب أو البريد': 'Phone, WhatsApp, or email',
  'طريقة عرض السعر': 'Price display format',
  'كلمات لا يجب استخدامها': 'Words to avoid',
  'لون هوية العميل': 'Client brand color',
  'نبرة الكتابة': 'Writing tone',
  'هوية الوكالة والعميل': 'Agency and client identity',
  'مثال: وكالة الهدف للتسويق': 'e.g. Istihdaf Marketing Agency',
  'مثال: اسم الشركة أو العلامة': 'e.g. Company or brand name',
};

// ===== الملف الشخصي (profile) =====
const staticUi_profile: Record<string, string> = {
  'آخر نشاط:': 'Last active:',
  'أدخل كلمة مرورك الحالية لتعطيل التفعيل الثنائي.': 'Enter your current password to disable two-factor authentication.',
  'أدخل كلمة مرورك الحالية لتفعيل التفعيل الثنائي.': 'Enter your current password to enable two-factor authentication.',
  'الأجهزة اللي سجّلت الدخول منها لحسابك. لو فيه جهاز مش عارفه، سجّل خروجه فوراً وغيّر كلمة المرور.': 'The devices that have signed in to your account. If you don\\\'t recognize a device, sign it out immediately and change your password.',
  'الأجهزة النشطة': 'Active devices',
  'التفعيل الثنائي (2FA)': 'Two-factor authentication (2FA)',
  'التفعيل الثنائي مفعّل حالياً على حسابك.': 'Two-factor authentication is currently enabled on your account.',
  'تعذر تسجيل الخروج من هذا الجهاز': 'Couldn\\\'t sign out this device',
  'تم تسجيل الخروج من الجهاز بنجاح': 'Successfully signed out the device',
  'تم تعطيل التفعيل الثنائي': 'Two-factor authentication disabled',
  'تم تفعيل التفعيل الثنائي بنجاح': 'Two-factor authentication enabled successfully',
  'دخول:': 'Signed in:',
  'لا توجد أجهزة مسجّلة حالياً.': 'No devices currently registered.',
  'لما يكون مفعّل، هيطلب منك كود تأكيد يوصلك بالبريد الإلكتروني في كل مرة تسجّل فيها الدخول. ننصح بتفعيلها خصوصاً لو حسابك عليه باقة مدفوعة.': 'When enabled, you\\\'ll be asked for a confirmation code sent to your email every time you sign in. We recommend enabling it especially if your account has a paid plan.',
  'هذا الجهاز': 'This device',
  'هذه كلمة مرور مؤقتة. غيّرها من قسم كلمة المرور أدناه قبل متابعة استخدام الحساب.': 'This is a temporary password. Change it from the password section below before continuing to use your account.',
};

// ===== سكريبت الريلز (reels) =====
const staticUi_reels: Record<string, string> = {
  'توليد سكريبت فيديو قصير': 'Generate short-form video script',
  'المنصة': 'Platform',
  'المدة': 'Duration',
  'توليد السكريبت': 'Generate script',
  'الموسيقى المقترحة:': 'Suggested music:',
  'مشاهد الفيديو': 'Video scenes',
  'المدة:': 'Duration:',
  'التعليق الصوتي (Voiceover)': 'Voiceover',
  'نسخ النص': 'Copy text',
  'النص على الشاشة': 'On-screen text',
  'المشهد البصري (B-Roll)': 'Visual scene (B-Roll)',
  'انستغرام Reels': 'Instagram Reels',
  'حدث خطأ أثناء توليد السكريبت. برجاء المحاولة مرة أخرى.': 'An error occurred while generating the script. Please try again.',
};

// ===== النشر متعدد المنصات (multiplatform) =====
const staticUi_multiplatform: Record<string, string> = {
  'جاري التوليد...': 'Generating...',
  'توليد إعلانات متعددة المنصات': 'Generate multi-platform ads',
  'استهداف شامل': 'Omnichannel targeting',
  'قم بتوليد نسخ إعلانية مخصصة بالكامل لكل منصة بناءً على تفاصيل مشروعك.': 'Generate fully customized ad copy for each platform based on your project details.',
  'توليد الإعلانات الآن': 'Generate ads now',
  'النسخ الإعلانية (Variations)': 'Ad variations',
  'نسخة': 'Variation',
  'الخطاف (Hook)': 'Hook',
  'السكريبت': 'Script',
  'الهاشتاجات': 'Hashtags',
  'العناوين (Headlines) - بحد أقصى 30 حرف': 'Headlines — maximum 30 characters',
  'الأوصاف (Descriptions) - بحد أقصى 90 حرف': 'Descriptions — maximum 90 characters',
  'كلمات مفتاحية (Keywords)': 'Keywords',
  'كلمات سلبية (Negative)': 'Negative keywords',
  'النص الأساسي': 'Primary text',
  'نصائح الاستهداف': 'Targeting tips',
  'العنوان (Headline)': 'Headline',
  'نصائح الاستهداف (B2B)': 'B2B targeting tips',
  'حدث خطأ أثناء توليد الإعلانات. برجاء المحاولة مرة أخرى.': 'An error occurred while generating ads. Please try again.',
};

// ===== تحليل المنافسين (competitor) =====
const staticUi_competitor: Record<string, string> = {
  'تحليل إعلانات المنافسين': 'Competitor ad analysis',
  'نص إعلان المنافس': 'Competitor ad copy',
  'الصق نص إعلان المنافس هنا...': 'Paste the competitor ad here...',
  'جاري التحليل...': 'Analyzing...',
  'تحليل الإعلان': 'Analyze ad',
  'نتيجة التحليل': 'Analysis result',
  'قوة الإعلان:': 'Ad strength:',
  'الزاوية التسويقية': 'Marketing angle',
  'نقاط القوة': 'Strengths',
  'نقاط الضعف': 'Weaknesses',
  'المحفز العاطفي': 'Emotional trigger',
  'الاستراتيجية المضادة (Counter Strategy)': 'Counter strategy',
  'الزاوية المقترحة لك': 'Recommended angle',
  'خطاف مقترح (Hook)': 'Suggested hook',
  'النص الأساسي المقترح': 'Suggested primary text',
  'كيف تتفوق عليهم؟': 'How to outperform them',
  'حدث خطأ أثناء تحليل الإعلان. برجاء المحاولة مرة أخرى.': 'An error occurred while analyzing the ad. Please try again.',
};

// ===== معاينة الإعلان (preview) =====
const staticUi_preview: Record<string, string> = {
  'مُموَّل (Sponsored)': 'Sponsored',
  'إعجاب': 'Like',
  'تعليق': 'Comment',
  'مشاركة': 'Share',
};

// ===== الرئيسية (dashboard) =====
const staticUi_dashboard: Record<string, string> = {
  'الحملات المحفوظة': 'Saved campaigns',
  'أي حملة نبني اليوم؟': 'What campaign should we build today?',
  'حوّل تفاصيل أي عرض إلى جمهور دقيق، تقدير تكلفة نتيجة، وخطة حملة قابلة للتنفيذ خلال دقائق.': 'Turn any offer into a precise audience, estimated result cost, and an execution-ready campaign plan in minutes.',
  'آخر الحملات': 'Recent campaigns',
  'أضف حملتك الأولى، ودع استهداف يبني لك استراتيجية التسويق المناسبة لمجالك.': 'Add your first campaign and let Istihdaf build a marketing strategy tailored to your industry.',
  'إنشاء حملة': 'Create campaign',
  'أهلاً': 'Welcome',
  'اسأل استهداف': 'Ask Istihdaf',
  'في مساحة العمل': 'In your workspace',
  'عملية ذكاء اصطناعي': 'AI operations',
  'حساب نشط': 'Active account',
  'افهم الطلب وتكلفة الليد': 'Understand demand and lead cost',
  'إنشاء استراتيجية جديدة': 'Create a new strategy',
  'الباقة الحالية': 'Current plan',
  'مساحة العمل': 'Workspace',
  'عرض الكل': 'View all',
  'اختصارات ذكية': 'Smart shortcuts',
  'ابدأ من هنا': 'Start here',
  'تحليلات السوق وCPL': 'Market & CPL insights',
  'مساعد استهداف AI': 'Istihdaf AI Assistant',
  'اسأل عن الجمهور والميزانية': 'Ask about audiences and budgets',
  'الباقة والاستخدام': 'Plan & usage',
  'راجع رصيدك ومزاياك': 'Review your credits and benefits',
};

// ===== صفحة مراجعة العميل (client_review) =====
const staticUi_client_review: Record<string, string> = {
  'العميل': 'Client',
  'توزيع الميزانية وخطة التنفيذ': 'Budget breakdown & execution plan',
  'الموقع': 'Location',
  'اسمك': 'Your name',
  'إضافة الملاحظة': 'Add comment',
  'أضف ملاحظة محددة': 'Add a specific comment',
  'الجمهور والاستهداف': 'Audience and targeting',
  'الحملة معتمدة': 'Campaign approved',
  'الرابط غير صالح أو لم يعد متاحًا.': 'The link is invalid or no longer available.',
  'القسم': 'Section',
  'الملاحظات السابقة': 'Previous comments',
  'الملاحظة': 'Comment',
  'النسخ الإعلانية المقترحة': 'Proposed ad copies',
  'بانتظار قرارك': 'Awaiting your decision',
  'تعذر فتح رابط المراجعة': 'Could not open the review link.',
  'تعليق على الملف': 'Comment on the file',
  'تم اعتماد الحملة وإبلاغ فريق العمل': 'The campaign was approved and the team was notified.',
  'تم إنشاؤه بواسطة منصة استهداف': 'Created with Istihdaf',
  'تم تسجيل طلب التعديل وإبلاغ فريق العمل': 'The change request was recorded and the team was notified.',
  'تم طلب تعديلات': 'Changes requested',
  'تمت إضافة الملاحظة إلى ملف الحملة': 'The comment was added to the campaign file.',
  'جاري تحميل ملف الحملة...': 'Loading campaign file...',
  'طلب تعديلات': 'Request changes',
  'مراجعة استراتيجية حملة': 'Campaign strategy review',
  'مقدم إلى': 'Prepared for',
  'ملخص القرار': 'Decision summary',
  'ملف مراجعة خاص وآمن': 'Private and secure review file',
  'يرجى كتابة الاسم والملاحظة': 'Enter your name and comment.',
  'يمكنك اعتماد الملف أو طلب تعديلات، وسيظهر قرارك مباشرة داخل مساحة عمل الفريق.': 'You can approve the file or request changes, and your decision will appear immediately in the team workspace.',
  'هذه النسخة ما زالت مسودة': 'This version is still a draft',
  'اسم المعتمد': 'Approver name',
  'الصفة الوظيفية': 'Job title',
  'البريد الإلكتروني (اختياري)': 'Email (optional)',
  'أقر بأنني راجعت محتوى الحملة وأوافق على اعتماده إلكترونيًا.': 'I confirm that I reviewed and electronically approve the campaign content.',
  'اعتماد الحملة إلكترونيًا': 'Approve campaign electronically',
  'المعتمد': 'Approver',
  'سيتم تفعيل التعليقات والاعتماد بعد إرسال فريق العمل لهذه المسودة للمراجعة.': 'Comments and approval will be enabled after the team sends this draft for review.',
  'تصدير PDF': 'Export PDF',
};

// ===== محاكي الحملة (simulator) =====
const staticUi_simulator: Record<string, string> = {
  'المنطقة': 'Region',
  'الجمهور': 'Audience',
  'محاكاة قبل الإنفاق': 'Plan before spending',
  'محاكي الحملة والميزانية': 'Campaign & budget simulator',
  'عدّل الافتراضات وشاهد نطاقًا تقديريًا للنتائج قبل اعتماد الميزانية.': 'Adjust assumptions and preview estimated results before approving the budget.',
  'الميزانية الإجمالية': 'Total budget',
  'مدة الحملة بالأيام': 'Campaign duration in days',
  'الهدف الإعلاني': 'Advertising objective',
  'السيناريو': 'Scenario',
  'الوصول المتوقع': 'Estimated reach',
  'العملاء المحتملون': 'Leads',
  'تكلفة العميل CPL': 'Lead cost (CPL)',
  'هذه تقديرات تخطيطية وليست ضمانًا للنتائج الفعلية. تتحسن الدقة بعد إدخال نتائج أول أيام التشغيل.': 'These are planning estimates, not guaranteed results. Accuracy improves after the first live results.',
  'حفظ افتراضات المحاكاة': 'Save simulation assumptions',
};

// ===== حزمة الإطلاق (launch) =====
const staticUi_launch: Record<string, string> = {
  'نسخ': 'Copy',
  'اليوم': 'Today',
  'جاهزة للتسليم والتنفيذ': 'Ready to deliver and execute',
  'حزمة إطلاق كاملة': 'Complete launch package',
  'حفظ الحزمة': 'Save package',
  'تصدير التقرير': 'Export report',
  'استراتيجية الجمهور': 'Audience strategy',
  'توزيع الميزانية': 'Budget allocation',
  'العناوين والخطافات': 'Headlines & hooks',
  'أفكار التصميم والفيديو': 'Creative & video ideas',
  'خطة المحتوى': 'Content plan',
  'الصيغة': 'Format',
  'الموضوع': 'Topic',
  'الإجراء': 'Action',
  'روابط UTM': 'UTM links',
  'قائمة الفحص قبل الإطلاق': 'Pre-launch checklist',
  'رابط صفحة الهبوط': 'Landing page URL',
  'تم النسخ إلى الحافظة': 'Copied to clipboard',
};

// ===== ودجت الدعم الفني (support_widget) =====
const staticUi_support_widget: Record<string, string> = {
  'أي ملاحظات إضافية؟ (اختياري)': 'Any additional feedback? (optional)',
  'إرسال التقييم': 'Submit rating',
  'ابدأ محادثة جديدة': 'Start a new conversation',
  'اسألنا عن أي حاجة محتاج تعرفها عن استهداف': 'Ask us anything you need to know about Istihdaf',
  'اكتب رسالتك هنا...': 'Type your message here...',
  'اكتب مشكلتك أو سؤالك وهيرد عليك المساعد الآلي فوراً': 'Type your issue or question and the assistant will reply instantly',
  'الدعم الفني': 'Technical support',
  'المحادثة مغلقة': 'Conversation closed',
  'المساعد الآلي يرد الآن': 'The assistant is replying now',
  'بانتظار موظف الدعم': 'Waiting for a support agent',
  'تحدث مع موظف الدعم الفني': 'Talk to a support agent',
  'تعذر إرسال الرسالة': 'Couldn\\\'t send the message',
  'تعذر التحويل لموظف الدعم': 'Couldn\\\'t transfer to a support agent',
  'تعذر حفظ التقييم': 'Couldn\\\'t save the rating',
  'جاري التحويل...': 'Transferring...',
  'جاري تحويلك لموظف الدعم الفني': 'Transferring you to a support agent',
  'حدث خطأ': 'An error occurred',
  'سجل المحادثات': 'Conversation history',
  'شكراً لتقييمك!': 'Thanks for your rating!',
  'قيّم تجربتك مع الدعم الفني': 'Rate your support experience',
  'كيف نقدر نساعدك؟': 'How can we help you?',
  'لم يتم التقييم': 'Not rated',
  'محادثة جديدة': 'New conversation',
  'موظف الدعم يرد الآن': 'The support agent is replying now',
  'نجوم': 'stars',
  'هذه المحادثة مغلقة.': 'This conversation is closed.',
};

// ===== لوحة الدعم الفني (أدمن) (support) =====
const staticUi_support: Record<string, string> = {
  'إرسال': 'Send',
  'بانتظار موظف': 'Waiting for an agent',
  'نشطة': 'Active',
  'البوت يرد': 'Bot replying',
  'مغلقة': 'Closed',
  'تعذر إرسال الرد': 'Couldn\'t send the reply',
  'تم إغلاق المحادثة': 'Conversation closed',
  'تعذر إغلاق المحادثة': 'Couldn\'t close the conversation',
  'تم فتح المحادثة مجدداً': 'Conversation reopened',
  'تعذر فتح المحادثة': 'Couldn\'t reopen the conversation',
  'نشطة الآن': 'Active now',
  'يرد عليها البوت': 'Bot is replying',
  'أُغلقت اليوم': 'Closed today',
  'متوسط التقييم': 'Average rating',
  'لا توجد محادثات في هذا التصنيف': 'No conversations in this category',
  'اختر محادثة من القائمة لعرض تفاصيلها': 'Select a conversation from the list to view its details',
  'إعادة فتح': 'Reopen',
  'إغلاق المحادثة': 'Close conversation',
  'ملاحظة العميل عند التقييم:': 'Customer\'s note with the rating:',
  'اكتب ردك للعميل...': 'Write your reply to the customer...',
};

// ===== لوحة تحكم الأدمن (admin) =====
const staticUi_admin: Record<string, string> = {
  'بيانات الحملة': 'Campaign details',
  'تسجيل الخروج': 'Sign out',
  'جاري الإرسال...': 'Sending...',
  'نظرة عامة': 'Overview',
  'الرصيد المتبقي': 'Remaining credits',
  'حالة الحساب': 'Account status',
  'غير محدود': 'Unlimited',
  'مجانية': 'Free',
  'من': 'of',
  'السابق': 'Back',
  'التالي': 'Next',
  'اسم صاحب الحساب': 'Account holder name',
  'رقم المحفظة': 'Wallet number',
  'اسم صاحب المحفظة': 'Wallet holder name',
  'إضافة مستخدم': 'Add user',
  'إجمالي الحسابات المسجلة': 'Total registered accounts',
  'مستخدم نشط على المنصة': 'active users on the platform',
  'الحسابات المجانية (Free)': 'Free accounts',
  'تنشيط تلقائي عند التسجيل': 'Activated automatically on signup',
  'الباقة الاحترافية (Pro)': 'Pro plan',
  'مكتملة بالترقية اليدوية': 'Manually upgraded',
  'باقة الوكالات (Agency)': 'Agency plan',
  'غير محدودة الرصيد': 'Unlimited credits',
  'إجمالي الحملات المولدة': 'Total generated campaigns',
  'الفئة العمرية الأكثر بين المستخدمين': 'Most common user age group',
  'الفئة الأكثر شيوعاً': 'Most common group',
  'لا توجد بيانات تاريخ ميلاد كافية بعد': 'Not enough birth date data yet',
  'مستخدم بدون تاريخ ميلاد مسجّل': 'users without a saved birth date',
  'عدد الحسابات الجديدة': 'New accounts',
  'اختر المدة الزمنية المطلوبة': 'Choose a date range',
  'من تاريخ': 'From date',
  'إلى تاريخ': 'To date',
  'حساب جديد —': 'new accounts —',
  'التحكم في أسعار الباقات': 'Plan pricing controls',
  'تعديل السعر والرصيد — يتحدث فوراً في صفحة Pricing للمستخدمين': 'Edit prices and credits — changes appear instantly on the Pricing page.',
  'حالياً:': 'Current:',
  'ج.م /': 'EGP /',
  'كريدت': 'credits',
  'السعر (بالقروش)': 'Price (in piasters)',
  '49900 = 499 ج.م': '49900 = 499 EGP',
  'عدد الكريدتات': 'Credit count',
  'اسم الباقة (عربي)': 'Plan name (Arabic)',
  'جاري الحفظ...': 'Saving...',
  'حفظ التغييرات': 'Save changes',
  'السعر يُدخل بالقروش (cents) — 1 جنيه = 100 قرش | مثال: 499 ج.م = اكتب 49900': 'Enter the price in piasters — 1 EGP = 100 piasters | Example: for 499 EGP, enter 49900',
  'إضافة حساب جديد': 'Add a new account',
  'إلغاء': 'Cancel',
  'الاسم الكامل': 'Full name',
  'أحمد علي': 'Ahmed Ali',
  'البريد الإلكتروني': 'Email address',
  'رقم الهاتف': 'Phone number',
  'الباقة المخصصة': 'Assigned plan',
  'مجانية (Free)': 'Free',
  'Pro (فردي)': 'Pro (Individual)',
  'Agency (وكالات)': 'Agency',
  'إضافة الحساب': 'Add account',
  'بحث...': 'Search...',
  'تصفية الباقة:': 'Filter plan:',
  'قائمة الحسابات المسجلة': 'Registered accounts',
  'عرض': 'Showing',
  'مستخدم': 'users',
  'المستخدم': 'User',
  'البريد والهاتف': 'Email & phone',
  'بيانات الملف الشخصي': 'Profile data',
  'الباقة الحالية (الترقية اليدوية)': 'Current plan (manual upgrade)',
  'التاريخ': 'Date',
  'إجراءات التحكم': 'Management actions',
  'لا يوجد مستخدمين مطبق عليهم هذا البحث': 'No users match this search',
  'الوكيل': 'Owner',
  'غير مسجّل': 'Not provided',
  'ترقية إلى Pro فردي': 'Upgrade to Pro',
  'ترقية إلى Agency وكالات': 'Upgrade to Agency',
  'عدد الأيام المتبقية قبل رجوع الحساب تلقائياً للباقة المجانية': 'Days remaining before automatic downgrade to Free',
  'باقي': 'Remaining',
  'يوم': 'days',
  'إضافة 5 رصيد': 'Add 5 credits',
  'إضافة 20 رصيد': 'Add 20 credits',
  'تعيين 100 رصيد': 'Set 100 credits',
  'حذف المستخدم': 'Delete user',
  'إجراء': 'Action',
  'الكل': 'All',
  'سنة': 'years',
  'تم حفظ إعدادات باقة': 'Plan settings saved for',
  'بنجاح': 'successfully',
  'بناءً على تاريخ الميلاد المسجّل في الملف الشخصي': 'Based on birth dates saved in profiles',
  'آخر 7 أيام': 'Last 7 days',
  'صلاحيات المالك': 'Owner access',
  'مركز قيادة استهداف': 'Istihdaf Command Center',
  'راقب نمو المنصة، أدر المستخدمين والباقات، واضبط تجربة المنتج من مكان واحد.': 'Monitor platform growth, manage users and plans, and configure the product experience from one place.',
  'تصدير المستخدمين': 'Export users',
  'حالة المنصة': 'Platform health',
  'مستقرة': 'Stable',
  'العنوان': 'Headline',
  'إعادة تعيين': 'Reset',
  'اللون الأساسي': 'Primary color',
  'تحكّم في ألوان وخط الموقع': 'Control the site colors and typography',
  'تخصيص مظهر الموقع': 'Customize site appearance',
  'تم حفظ إعدادات المظهر بنجاح': 'Appearance settings saved successfully.',
  'حدث خطأ أثناء حفظ الإعدادات': 'An error occurred while saving the settings.',
  'حفظ': 'Save',
  'خط الموقع': 'Site font',
  'زر تفاعلي': 'Interactive button',
  'لون التمييز': 'Accent color',
  'معاينة': 'Preview',
  'نموذج لعنوان رئيسي': 'Sample primary heading',
  'هذا النص يعرض المعاينة الحية للخطوط والألوان المختارة.': 'This text previews the selected typography and colors live.',
  'حساب نشط من أصل': 'active accounts out of',
  'استراتيجية مولّدة عبر المنصة': 'strategies generated across the platform',
  'أقسام لوحة المالك': 'Owner dashboard sections',
  'المستخدمون': 'Users',
  'الباقات والأسعار': 'Plans & pricing',
  'هوية الموقع': 'Site identity',
  'الترجمات': 'Translations',
  'الحالة': 'Status',
  'سجل النشاط': 'Activity log',
  'إجراءات': 'Actions',
  'تحليلات المنتج': 'Product analytics',
  'الأحداث ذات القيمة': 'High-value events',
  'مسار تبنّي المنتج': 'Product adoption funnel',
  'يوضح عدد المستخدمين الذين وصلوا إلى كل حدث أساسي، من أول حملة حتى الترقية.': 'Shows how many users reached each key event, from the first campaign through upgrade.',
  'الحدث': 'Event',
  'إجمالي الأحداث': 'Total events',
  'آخر تسجيل': 'Last recorded',
  'تمت إضافة عضو الفريق بنجاح': 'Team member added successfully',
  'تعذر إضافة عضو الفريق': 'Couldn\'t add team member',
  'تعذر تحديث صلاحيات العضو': 'Couldn\'t update member\'s permissions',
  'حذف هذا العضو من فريق الإدارة؟ سيفقد الوصول لكل الأقسام المخصصة له فوراً.': 'Remove this member from the admin team? They will immediately lose access to all sections assigned to them.',
  'تعذر حذف العضو': 'Couldn\'t remove the member',
  'سيتم إرسال هذه الرسالة فعلياً لكل المشتركين المطابقين للفئة المختارة. متأكد؟': 'This message will actually be sent to every subscriber matching the selected category. Are you sure?',
  'تم الإرسال بنجاح': 'Sent successfully',
  'تعذر إرسال الرسالة الجماعية': 'Couldn\'t send the broadcast message',
  'تعذر جلب رسائل صندوق البريد': 'Couldn\'t fetch inbox messages',
  'تعذر جلب الرسالة': 'Couldn\'t fetch the message',
  'تسجيل الخروج من كل أجهزة هذا المستخدم؟ سيحتاج لتسجيل الدخول من جديد على كل أجهزته.': 'Sign this user out of all their devices? They\'ll need to log in again on every device.',
  'تعذر تغيير كلمة المرور': 'Couldn\'t change the password',
  'تم إنشاء كود الخصم بنجاح': 'Discount code created successfully',
  'تعذر إنشاء كود الخصم': 'Couldn\'t create the discount code',
  'تعذر تحديث حالة الكود': 'Couldn\'t update the code\'s status',
  'هل تريد حذف كود الخصم': 'Delete the discount code',
  'تعذر حذف الكود': 'Couldn\'t delete the code',
  'تم إضافة الرابط بنجاح': 'Link added successfully',
  'تعذر إضافة الرابط': 'Couldn\'t add the link',
  'تعذر تحديث حالة الرابط': 'Couldn\'t update the link\'s status',
  'هل تريد حذف رابط': 'Delete the link',
  'تعذر حذف الرابط': 'Couldn\'t delete the link',
  'تم حفظ التعديلات': 'Changes saved',
  'تعذر حفظ التعديلات': 'Couldn\'t save the changes',
  'تعذر إعادة ترتيب الروابط': 'Couldn\'t reorder the links',
  'من فضلك أدخل رقماً صحيحاً موجباً': 'Please enter a positive whole number',
  'تم حفظ الحد الأقصى بنجاح': 'Limit saved successfully',
  'حدث خطأ أثناء الحفظ': 'An error occurred while saving',
  'نسبة الضريبة يجب أن تكون رقماً بين 0 و100': 'The tax rate must be a number between 0 and 100',
  'تم حفظ بيانات التحويل بنجاح': 'Transfer details saved successfully',
  'تأكيد استلام التحويل وترقية باقة المستخدم؟': 'Confirm the transfer was received and upgrade the user\'s plan?',
  'تم اعتماد الدفعة وترقية الباقة بنجاح': 'Payment approved and plan upgraded successfully',
  'تعذر اعتماد الدفعة': 'Couldn\'t approve the payment',
  'سبب الرفض (اختياري):': 'Reason for rejection (optional):',
  'تم رفض الدفعة': 'Payment rejected',
  'تعذر رفض الدفعة': 'Couldn\'t reject the payment',
  'عضو فريق الإدارة': 'Admin team member',
  'لوحة تحكم فريق الإدارة': 'Admin team dashboard',
  'لديك وصول للأقسام المخصصة لك فقط من قِبل مالك المنصة.': 'You only have access to the sections assigned to you by the platform owner.',
  'الحملات والمحادثات': 'Campaigns & conversations',
  'المدفوعات': 'Payments',
  'الرسائل الجماعية': 'Broadcast messages',
  'صندوق وارد المنصة': 'Platform inbox',
  'أكواد الخصم': 'Discount codes',
  'الشات بوت': 'Chatbot',
  'روابط الفوتر': 'Footer links',
  'فريق الإدارة': 'Admin team',
  'حلقة الدقة': 'Accuracy loop',
  'دقة توقعات الذكاء الاصطناعي': 'AI forecast accuracy',
  'مقارنة مدى تكلفة الليد (CPL) اللي توقّعه الذكاء الاصطناعي بالنتائج الفعلية اللي أدخلها المستخدمون بعد تشغيل حملاتهم على ميتا/تيك توك.': 'Comparing the AI\'s predicted cost-per-lead (CPL) range against the actual results users entered after running their campaigns on Meta/TikTok.',
  'لا توجد نتائج فعلية مُدخَلة كفاية بعد للمقارنة — شجّع المستخدمين على إدخال نتائج حملاتهم من تبويب "إصدارات الحملة".': 'Not enough actual results have been entered yet for comparison — encourage users to enter their campaign results from the "Campaign Versions" tab.',
  'حملات مقيسة': 'Measured campaigns',
  'دقة داخل المدى المتوقع تمامًا': 'Fully within the predicted range',
  'دقة بهامش معقول (±15%)': 'Within a reasonable margin (±15%)',
  'متوسط الانحراف عن المدى': 'Average deviation from the range',
  'صحة الذكاء الاصطناعي': 'AI health',
  'نسبة نجاح/فشل طلبات توليد الحملات ومتوسط زمن الاستجابة، مقسّمة على كل مفتاح Gemini في نظام الـ Round-Robin.': 'Success/failure rate of campaign generation requests and average response time, broken down by each Gemini key in the round-robin system.',
  'لا توجد بيانات كافية بعد خلال آخر 7 أيام': 'Not enough data yet over the last 7 days',
  'إجمالي الطلبات': 'Total requests',
  'نسبة النجاح': 'Success rate',
  'متوسط زمن الاستجابة': 'Average response time',
  'عدد الطلبات': 'Number of requests',
  'مفتاح': 'Key',
  'النمو': 'Growth',
  'معدل التحويل من مجاني إلى مدفوع': 'Free-to-paid conversion rate',
  'كام حساب استهلك كل رصيده المجاني، وكام حساب اتحوّل فعلاً لباقة مدفوعة على الأقل مرة.': 'How many accounts used up all their free credits, and how many actually upgraded to a paid plan at least once.',
  'إجمالي الحسابات': 'Total accounts',
  'مجانيون استهلكوا كل الرصيد الآن': 'Free users who have used up all their credits',
  'تحوّلوا لمدفوع مرة على الأقل': 'Converted to paid at least once',
  'معدل التحويل الإجمالي': 'Overall conversion rate',
  'الاحتفاظ': 'Retention',
  'احتفاظ المستخدمين حسب شهر التسجيل': 'User retention by signup month',
  'من كل مجموعة سجّلت في شهر معيّن، النسبة اللي لسه شغالة بعد شهرين من تسجيلها.': 'For each cohort that signed up in a given month, the percentage still active two months after signing up.',
  'لا توجد مجموعات مضى عليها شهرين كافيين للقياس بعد': 'No cohorts have reached the two-month mark yet for measurement',
  'شهر التسجيل': 'Signup month',
  'حجم المجموعة': 'Cohort size',
  'لسه نشطون بعد شهرين': 'Still active after two months',
  'نسبة الاحتفاظ': 'Retention rate',
  'التحكم في الشات بوت': 'Chatbot controls',
  'حد عدد الرسائل الشهري المسموح به لمستخدمي النسخة المجانية': 'Monthly message limit allowed for free-plan users',
  'الحد الأقصى لرسائل الشات بوت شهرياً (النسخة المجانية)': 'Maximum chatbot messages per month (free plan)',
  'مثال: 100': 'e.g. 100',
  'العدّاد بيتصفّر تلقائياً أول كل شهر ميلادي لكل مستخدم على حدة.': 'The counter resets automatically at the start of each calendar month, per user.',
  'أكواد الخصم على الباقات': 'Discount codes for plans',
  'كل كود صالح مرة واحدة فقط لكل حساب — يظهر للمستخدم كخانة اختيارية في صفحة الباقات': 'Each code is valid once per account — it appears to the user as an optional field on the pricing page',
  'إنشاء كود جديد': 'Create new code',
  'الكود': 'Code',
  'نوع الخصم': 'Discount type',
  'نسبة %': 'Percentage %',
  'مبلغ ثابت (ج.م)': 'Fixed amount (EGP)',
  'النسبة %': 'Percentage %',
  'المبلغ (ج.م)': 'Amount (EGP)',
  'جاري الإنشاء...': 'Creating...',
  'إنشاء الكود': 'Create code',
  'لا توجد أكواد خصم بعد': 'No discount codes yet',
  'الخصم': 'Discount',
  'مرات الاستخدام': 'Times used',
  'مفعّل': 'Enabled',
  'موقوف': 'Disabled',
  'إيقاف': 'Disable',
  'تفعيل': 'Enable',
  'حذف': 'Delete',
  'روابط فوتر الواجهة الرئيسية': 'Main interface footer links',
  'تحكّم في الروابط الظاهرة أسفل الواجهة الرئيسية بعد تسجيل الدخول — إضافة، تعديل، حذف، وإعادة ترتيب': 'Manage the links shown at the bottom of the main interface after login — add, edit, delete, and reorder',
  'إضافة رابط جديد': 'Add new link',
  'الاسم بالعربي': 'Name in Arabic',
  'مثال: من نحن': 'e.g. About us',
  'الاسم بالإنجليزي': 'Name in English',
  'الرابط (مسار داخلي مثل ‎/about أو رابط كامل https://)': 'Link (an internal path like /about, or a full https:// URL)',
  'فتح الرابط في تبويب جديد': 'Open link in a new tab',
  'جاري الإضافة...': 'Adding...',
  'إضافة الرابط': 'Add link',
  'لا توجد روابط في الفوتر بعد — أضف أول رابط من الفورم فوق': 'No footer links yet — add the first one using the form above',
  'الترتيب': 'Order',
  'الاسم (عربي / إنجليزي)': 'Name (Arabic / English)',
  'الرابط': 'Link',
  'تحريك لأعلى': 'Move up',
  'تحريك لأسفل': 'Move down',
  'تبويب جديد': 'New tab',
  'تعديل': 'Edit',
  'إرسال رسالة جماعية للمشتركين': 'Send a broadcast message to subscribers',
  'اختر الفئة واكتب الرسالة — ستصل لكل مشترك مطابق باستثناء من ألغى اشتراكه': 'Choose the category and write the message — it will reach every matching subscriber except those who unsubscribed',
  'عنوان الرسالة': 'Message subject',
  'مثال: ميزة جديدة على استهداف': 'e.g. New feature on Istihdaf',
  'المستقبلون': 'Recipients',
  'كل المشتركين النشطين': 'All active subscribers',
  'الباقة المجانية': 'Free plan',
  'باقة Pro': 'Pro plan',
  'باقة Agency': 'Agency plan',
  'الحسابات الموقوفة': 'Suspended accounts',
  'نص الرسالة': 'Message body',
  'اكتب نص الرسالة هنا... (يدعم HTML بسيط)': 'Write the message body here... (supports basic HTML)',
  'إرسال الآن': 'Send now',
  'سجل الرسائل السابقة': 'Message history',
  'لا توجد رسائل جماعية مُرسلة بعد': 'No broadcast messages sent yet',
  'الفئة': 'Category',
  'نجح / إجمالي': 'Sent / total',
  'الرسائل الواردة فعلياً على بريد المنصة': 'Messages actually received on the platform\'s email',
  'صندوق البريد ده لسه مش مُعد على السيرفر — لازم تضيف متغيرات IMAP الخاصة به في إعدادات الاستضافة أولاً.': 'This inbox is not yet configured on the server — you need to add its IMAP environment variables in the hosting settings first.',
  'لا توجد رسائل واردة حالياً': 'No incoming messages currently',
  'عيّن أشخاصاً بإيميلهم للوصول لأقسام محددة في لوحة التحكم دون منحهم صلاحية المالك الكاملة': 'Assign people by email to access specific dashboard sections without giving them full owner access',
  'إضافة عضو جديد': 'Add new member',
  'الاسم (اختياري)': 'Name (optional)',
  'الأقسام المسموح بها': 'Allowed sections',
  'إضافة العضو': 'Add member',
  'لا يوجد أعضاء في فريق الإدارة بعد': 'No admin team members yet',
  'آخر دخول والأجهزة': 'Last login & devices',
  'لم يسجّل دخول بعد': 'Hasn\'t logged in yet',
  'عرض الأجهزة المسجّل دخولها': 'View logged-in devices',
  'جهاز': 'Device',
  'إعادة تعيين كلمة المرور': 'Reset password',
  'كل الحملات على المنصة': 'All campaigns on the platform',
  'بحث باسم أو بريد صاحب الحملة...': 'Search by campaign owner\'s name or email...',
  'كل الباقات': 'All plans',
  'احترافية': 'Pro',
  'وكالات': 'Agency',
  'الأحدث أولاً': 'Newest first',
  'الأقدم أولاً': 'Oldest first',
  'حسب الباقة (وكالات ← احترافية ← مجانية)': 'By plan (Agency → Pro → Free)',
  'الأكثر نشاطاً (عدد حملات المستخدم)': 'Most active (user\'s campaign count)',
  'عنوان الحملة': 'Campaign title',
  'صاحب الحملة': 'Campaign owner',
  'الباقة': 'Plan',
  'حملات المستخدم': 'User\'s campaigns',
  'تاريخ الإنشاء': 'Created on',
  'جارِ التحميل...': 'Loading...',
  'لا توجد حملات': 'No campaigns',
  'عرض التفاصيل والمحادثات': 'View details & conversations',
  'بيانات التحويل اليدوي': 'Manual transfer details',
  'تظهر للمستخدمين وقت الاشتراك — إنستاباي ومحفظة إلكترونية': 'Shown to users when subscribing — Instapay and mobile wallet',
  'إنستاباي (Instapay)': 'Instapay',
  'المحفظة الإلكترونية': 'Mobile wallet',
  'نسبة الضريبة (VAT)': 'Tax rate (VAT)',
  'تُضاف هذه النسبة على سعر الباقة وقت الدفع الفعلي فقط، ولا تظهر في السعر المعروض بصفحة الأسعار.': 'This rate is added to the plan price only at actual checkout, and doesn\'t appear in the price shown on the pricing page.',
  'حفظ بيانات التحويل': 'Save transfer details',
  'سجل المدفوعات': 'Payment history',
  'تصدير CSV': 'Export CSV',
  'المبلغ': 'Amount',
  'الرقم المرجعي': 'Reference number',
  'تاريخ الدفع': 'Payment date',
  'لا توجد مدفوعات بعد': 'No payments yet',
  'رفض': 'Reject',
  'سجل نشاط الأدمن': 'Admin activity log',
  'بحث بالاسم أو الإيميل أو تفاصيل العملية...': 'Search by name, email, or operation details...',
  'كل العمليات': 'All operations',
  'الأدمن': 'Admin',
  'العملية': 'Operation',
  'على': 'On',
  'تفاصيل': 'Details',
  'لا يوجد نشاط مسجّل بعد': 'No activity recorded yet',
  'صفحة': 'Page',
  'محادثات هذا المستخدم مع الشات': 'This user\'s chat conversations',
  'لا توجد محادثات لهذا المستخدم': 'No conversations for this user',
  'اختر محادثة لعرض رسائلها': 'Select a conversation to view its messages',
  'الشات': 'Chat',
  'أجهزة': 'Devices',
  'آخر تسجيل دخول': 'Last login',
  'لا توجد أجهزة مسجّلة حالياً': 'No devices currently logged in',
  'غير معروفة': 'Unknown',
  'آخر نشاط': 'Last activity',
  'تسجيل الخروج من كل الأجهزة': 'Sign out of all devices',
  'إعادة تعيين كلمة مرور': 'Reset a password',
  'كلمات المرور مخزّنة مشفّرة بشكل لا يمكن الرجوع عنه، فلا يمكن عرض كلمة المرور الحالية لأي مستخدم. بدلاً من ذلك يمكنك توليد كلمة مرور جديدة ومشاركتها معه — سيتم تسجيل خروجه من كل أجهزته تلقائياً.': 'Passwords are stored with irreversible encryption, so no user\'s current password can be shown. Instead, you can generate a new password and share it with them — they\'ll be automatically signed out of all their devices.',
  'كلمة المرور الجديدة (انسخها الآن، لن تظهر مرة أخرى):': 'New password (copy it now, it won\'t be shown again):',
  'جارِ التوليد...': 'Generating...',
  'توليد كلمة مرور جديدة': 'Generate new password',
};

// ===== إدارة الترجمة (translation_manager) =====
const staticUi_translation_manager: Record<string, string> = {
  'الترجمة': 'Translations',
  'نص ثابت': 'static texts',
  'عدّل جميع نصوص واجهة الموقع بالعربية والإنجليزية. مخرجات الذكاء الاصطناعي غير مدرجة هنا ولن يتم تغييرها.': 'Edit all interface text in Arabic and English. AI-generated output is excluded and will not be changed.',
  'جاري حفظ الترجمات...': 'Saving translations...',
  'لا يمكن ترك النص العربي أو الإنجليزي فارغاً.': 'Arabic and English text cannot be empty.',
  'تم حفظ الترجمات وتطبيقها على الموقع بنجاح.': 'Translations were saved and applied successfully.',
  'تعذر حفظ الترجمات. حاول مرة أخرى.': 'Could not save translations. Please try again.',
  'ابحث بالمفتاح أو النص العربي أو الإنجليزي...': 'Search by key, Arabic text, or English text...',
  'كل النصوص': 'All text',
  'نصوص الأقسام الأساسية': 'Core section text',
  'النصوص الثابتة الإضافية': 'Additional static text',
  'المفتاح': 'Key',
  'النص العربي': 'Arabic text',
  'النص الإنجليزي': 'English text',
  'غير محفوظ': 'Unsaved',
  'استعادة النص الافتراضي': 'Restore default text',
  'لا توجد نصوص مطابقة للبحث.': 'No text matches your search.',
};

// ===== التهيئة الأولى (onboarding) =====
const staticUi_onboarding: Record<string, string> = {
  'إعداد مساحة عملك': 'Set up your workspace',
  'اختيار نوع النشاط': 'Choose business type',
  'إنشاء أول عميل': 'Create first client',
  'إدخال أول مشروع': 'Add first project',
  'توليد أول حملة': 'Generate first campaign',
  'إرسالها إلى العميل': 'Send it to the client',
  'نوع النشاط': 'Business type',
  'اختر': 'Select',
  'وكالة تسويق': 'Marketing agency',
  'مطور عقاري': 'Real estate developer',
  'شركة وساطة': 'Brokerage',
  'مسوّق مستقل': 'Independent marketer',
  'اسم أول عميل': 'First client name',
  'اسم أول مشروع': 'First project name',
  'متابعة الحملة': 'Continue campaign',
  'إنشاء أول حملة': 'Create first campaign',
  'إخفاء الآن': 'Hide for now',
};

// ===== عام / غير مصنّف (general) =====
const staticUi_general: Record<string, string> = {
  'خصم رصيد واحد': '1 credit will be deducted',
  'ضمن باقتك غير المحدودة': 'Included in your unlimited plan',
  'ابدأ من نموذج عقاري جاهز': 'Start from a real estate template',
  'الحملة': 'Campaign',
  'السوق والعرض': 'Market & offer',
  'العرض': 'Offer',
  'السعر والتحويل': 'Price & conversion',
  'التحويل': 'Conversion',
  'لنبدأ بأساسيات الحملة': 'Let’s start with the campaign basics',
  'اختر المجال أولاً ليبني الذكاء الاصطناعي الاستراتيجية والأسئلة والسياسات المناسبة له.': 'Choose the industry first so AI can tailor the strategy, questions, and policies.',
  'العقارات': 'Real estate',
  'التجارة الإلكترونية': 'E-commerce',
  'الخدمات المهنية': 'Professional services',
  'التعليم والتدريب': 'Education & training',
  'الصحة والعيادات': 'Healthcare & clinics',
  'المطاعم والكافيهات': 'Restaurants & cafes',
  'السيارات': 'Automotive',
  'مشروعات ووحدات ووساطة عقارية': 'Projects, units, and real estate brokerage',
  'منتجات ومتاجر وعروض بيع أونلاين': 'Products, stores, and online sales offers',
  'شركات وخبراء واستشارات وخدمات محلية': 'Companies, experts, consulting, and local services',
  'كورسات وأكاديميات ومدارس وبرامج تدريب': 'Courses, academies, schools, and training programs',
  'عيادات ومراكز وخدمات صحية ملتزمة بالسياسات': 'Policy-compliant clinics, centers, and healthcare services',
  'فروع وتوصيل وعروض وتجارب طعام': 'Branches, delivery, offers, and dining experiences',
  'بيع وتأجير وصيانة وخدمات سيارات': 'Vehicle sales, rentals, maintenance, and services',
  'زيادة المبيعات': 'Increase sales',
  'تحويل الجمهور إلى طلبات شراء مباشرة': 'Convert the audience into direct purchases',
  'جمع عملاء محتملين': 'Generate leads',
  'تجميع بيانات أشخاص مناسبين لفريق المبيعات': 'Collect qualified prospects for the sales team',
  'محادثات واتساب أو ماسنجر': 'WhatsApp or Messenger conversations',
  'بدء محادثات مباشرة مع العملاء المحتملين': 'Start direct conversations with prospects',
  'حجوزات ومواعيد': 'Bookings & appointments',
  'زيادة حجوزات الفروع أو الجلسات أو الاستشارات': 'Increase branch, session, or consultation bookings',
  'زيارات الموقع أو المتجر': 'Website or store traffic',
  'توجيه جمهور مؤهل إلى صفحة المنتج أو الخدمة': 'Drive qualified users to the product or service page',
  'انتشار ووعي بالعلامة': 'Brand awareness',
  'تعريف جمهور جديد بالعلامة وعرضها الأساسي': 'Introduce a new audience to the brand and its core offer',
  'إعادة استهداف العملاء السابقين': 'Retarget previous customers',
  'إعادة تنشيط الزوار والعملاء الذين تفاعلوا من قبل': 'Re-engage previous visitors and customers',
  'اسم المنتج أو الخدمة': 'Product or service name',
  'اسم العلامة أو الشركة': 'Brand or company name',
  'أين يوجد جمهورك وما العرض؟': 'Where is your audience and what is the offer?',
  'السوق المستهدف ووصف العرض يساعدان على بناء جمهور ورسالة أكثر دقة.': 'The target market and offer description help build a more precise audience and message.',
  'الدولة أو السوق المستهدف': 'Country or target market',
  'المدينة أو نطاق التوصيل': 'City or delivery area',
  'وصف المنتج أو الخدمة والعرض': 'Product, service, and offer description',
  'حدد سعر العرض والطريق الذي تريد أن يتخذه العميل بعد مشاهدة الإعلان.': 'Set the offer price and the action customers should take after seeing the ad.',
  'سعر المنتج أو الخدمة': 'Product or service price',
  'أهم مزايا المنتج أو الخدمة': 'Key product or service benefits',
  'مثال: توصيل سريع، ضمان، خبرة موثقة...': 'Example: Fast delivery, warranty, proven experience…',
  'وصف الجمهور المستهدف': 'Target audience description',
  'العلامة ووصف العرض': 'Brand & offer description',
  'السوق المستهدف': 'Target market',
  'يوضح قيمة العرض والإجراء المطلوب من العميل': 'Clarifies the offer value and the action expected from the customer',
  'السعر ومسار التحويل': 'Price & conversion path',
  'مزايا العرض': 'Offer benefits',
  'سعر العرض': 'Offer price',
  'مسار التحويل': 'Conversion path',
  'منتج أو خدمة': 'Product or service',
  'website': 'Website',
  'whatsapp': 'WhatsApp',
  'messages': 'Social messages',
  'calls': 'Phone calls',
  'store': 'Store visit',
  'القيمة العملية للعرض والنتيجة المتوقعة': 'Practical offer value and expected outcome',
  'المقارنة بين السعر والقيمة والثقة في مقدم العرض': 'Comparing price, value, and trust in the provider',
  'الحاجة إلى دليل واضح على قيمة العرض': 'Need for clear proof of offer value',
  'النطاق التفصيلي غير محدد؛ دقة الاستهداف الجغرافي قد تتحسن بإضافته.': 'The detailed area is missing; adding it may improve geographic targeting.',
  'عدد مزايا العرض محدود؛ يفضّل إضافة سببين واقعيين للاختيار.': 'The offer has few benefits; add at least two credible reasons to choose it.',
  'المنتج أو الخدمة': 'Product or service',
  'مراجعة بيانات العرض والسعر': 'Review offer details and price',
  'مراجعة سياسات Meta الخاصة بالمجال': 'Review Meta policies for this industry',
  'نوع الوحدة': 'Unit type',
  'الإشعارات': 'Notifications',
  'ابحث في مساحة العمل': 'Search workspace',
  'الذكاء والتحليلات': 'Intelligence',
  'ذكاء تسويقي عقاري متخصص': 'Purpose-built real estate marketing intelligence',
  'أي مشروع نستهدف اليوم؟': 'What project are we targeting today?',
  'حوّل تفاصيل المشروع إلى خريطة جمهور، تقدير CPL، وخطة حملة قابلة للتنفيذ خلال دقائق.': 'Turn project details into audience maps, CPL estimates, and an execution-ready campaign plan in minutes.',
  'استهداف أدق': 'Precision targeting',
  'إشارات سوقية': 'Market signals',
  'تقدير تكلفة الليد': 'CPL estimation',
  'تصور لإشارات السوق والاستهداف': 'Market and targeting signal visualization',
  'مؤشر الجاهزية': 'Readiness score',
  'بناءً على بياناتك': 'Based on your data',
  'لم تنشئ أي مشروع بعد': 'No projects yet',
  'أضف مشروعك الأول، ودع استهداف يبني لك استراتيجية التسويق.': 'Add your first project and let Istihdaf build the marketing strategy.',
  'إنشاء مشروع': 'Create project',
  'نبض السوق': 'Market pulse',
  'الطلب قوي على المشروعات السكنية': 'Residential project demand is strong',
  'مكتبة المشاريع': 'Project library',
  'راجع الاستراتيجيات المحفوظة، قارن البيانات، وواصل العمل من حيث توقفت.': 'Review saved strategies, compare data, and continue where you left off.',
  'مشروع محفوظ': 'Saved projects',
  'ابدأ بإضافة مشروعك الأول ودع استهداف يبني لك استراتيجية التسويق.': 'Add your first project and let Istihdaf build the marketing strategy.',
  'خطة السداد': 'Payment plan',
  'حفظ تلقائي': 'Autosave',
  'تحليل سوقي': 'Market analysis',
  'نتائج خلال دقائق': 'Results in minutes',
  'تم إزالة المشروع من المحفوظات': 'Project removed from saved items',
  'تم حفظ المشروع بنجاح': 'Project saved successfully',
  'تم حذف المشروع': 'Project deleted',
  'مساحة عمل التسويق العقاري بالذكاء الاصطناعي': 'AI real estate marketing workspace',
  'أهلًا': 'Welcome',
  '، ما المشروع الذي نستهدفه اليوم؟': ', what project are we targeting today?',
  'حوّل بيانات أي مشروع عقاري إلى جمهور دقيق، خطة حملة، ونسخ إعلانية جاهزة خلال دقائق.': 'Turn any real estate project into a precise audience, campaign plan, and ready-to-use ad copy in minutes.',
  'اسأل مساعد استهداف': 'Ask Istihdaf Assistant',
  'المشاريع المحفوظة': 'Saved projects',
  'آخر المشاريع': 'Recent projects',
  'لا توجد مشاريع محفوظة بعد': 'No saved projects yet',
  'ابدأ بأول استراتيجية وسيظهر مشروعك هنا.': 'Create your first strategy and it will appear here.',
  'افهم تكلفة الليد والطلب': 'Understand lead cost and demand',
  'لنبدأ بأساسيات المشروع': 'Let’s start with the project basics',
  'بيانات المشروع': 'Project details',
  'المشروع': 'Project',
  'الموقع والوحدة': 'Location & unit',
  'السعر والسداد': 'Price & payment',
  'السداد': 'Payment',
  'المزايا والجمهور': 'Features & audience',
  'هذه البيانات تساعد الذكاء الاصطناعي على فهم المنتج العقاري.': 'This information helps AI understand the real estate product.',
  'اسم المشروع': 'Project name',
  'اسم المطور': 'Developer name',
  'سكني': 'Residential',
  'تجاري / إداري': 'Commercial / Administrative',
  'ساحلي': 'Coastal',
  'أرض استثمارية': 'Investment land',
  'أين يقع المشروع؟': 'Where is the project located?',
  'الموقع ونوع الوحدة يحددان الجمهور ونطاق الاستهداف.': 'Location and unit type define the audience and targeting range.',
  'المنطقة الرئيسية': 'Main area',
  'تفاصيل الوحدة': 'Unit details',
  'السعر وخطة السداد': 'Price & payment plan',
  'نستخدمها لتقدير القوة الشرائية وجودة الجمهور وCPL.': 'We use this to estimate purchasing power, audience quality, and CPL.',
  'السعر يبدأ من': 'Starting price',
  'الجمهور والرسالة': 'Audience & message',
  'آخر خطوة قبل بناء الاستراتيجية والنسخ الإعلانية.': 'The final step before building your strategy and ad copy.',
  'أهم مميزات المشروع': 'Key project features',
  'مثال: موقع استراتيجي، مقدم 10%...': 'Example: prime location, 10% down payment...',
  'الجمهور المبدئي': 'Initial audience',
  'استراتيجيات استهداف ونسخ إعلانية عقارية جاهزة خلال دقائق.': 'Real estate targeting strategies and ad copy ready in minutes.',
  'منصة ذكاء اصطناعي متخصصة تساعد المسوقين والبروكرز على فهم الجمهور، تقدير CPL، وبناء حملة أدق.': 'A specialized AI platform that helps marketers and brokers understand audiences, estimate CPL, and build more precise campaigns.',
  'انضم إلينا وابدأ في بناء حملات عقارية ذكية.': 'Join us and start building smarter real estate campaigns.',
  'تحليل عقاري': 'Real estate analysis',
  'محاولات دخول كثيرة جداً. برجاء المحاولة مرة أخرى بعد قليل.': 'Too many login attempts. Please try again shortly.',
  'عدد كبير من محاولات إنشاء الحسابات من نفس الجهة. حاول لاحقاً.': 'Too many sign-up attempts from this source. Please try again later.',
  'طلبات كثيرة جداً. برجاء الانتظار قليلاً قبل المحاولة مرة أخرى.': 'Too many requests. Please wait before trying again.',
  'محاولات كثيرة جداً للتحقق من الكود. برجاء الانتظار قليلاً.': 'Too many code-verification attempts. Please wait before trying again.',
  'محاولات كثيرة جداً. برجاء المحاولة مرة أخرى بعد قليل.': 'Too many attempts. Please try again shortly.',
  'برجاء إدخال جميع البيانات المطلوبة (كلمة المرور 8 أحرف على الأقل)': 'Enter all required information. The password must be at least 8 characters.',
  'هذا البريد الإلكتروني مسجل بالفعل. يمكنك تسجيل الدخول.': 'This email address is already registered. You can sign in.',
  'تعذر إرسال كود التفعيل إلى بريدك الإلكتروني. تأكد من صحة البريد وحاول مرة أخرى.': 'Could not send the activation code. Check your email address and try again.',
  'حدث خطأ أثناء إنشاء الحساب': 'An error occurred while creating the account.',
  'يرجى إدخال البريد الإلكتروني وكود التفعيل': 'Enter your email address and activation code.',
  'لا يوجد كود تفعيل ساري لهذا البريد. اطلب كوداً جديداً.': 'There is no valid activation code for this email. Request a new code.',
  'انتهت صلاحية كود التفعيل. اطلب كوداً جديداً.': 'The activation code has expired. Request a new code.',
  'تجاوزت عدد المحاولات المسموح بها. اطلب كوداً جديداً.': 'You have exceeded the allowed attempts. Request a new code.',
  'كود التفعيل غير صحيح.': 'The activation code is incorrect.',
  'المستخدم غير موجود': 'User not found.',
  'حدث خطأ أثناء تفعيل البريد الإلكتروني': 'An error occurred while activating your email.',
  'يرجى إدخال البريد الإلكتروني': 'Enter your email address.',
  'البريد الإلكتروني غير مسجل': 'This email address is not registered.',
  'هذا البريد مُفعّل بالفعل، يمكنك تسجيل الدخول.': 'This email is already verified. You can sign in.',
  'يرجى الانتظار قليلاً قبل طلب كود جديد.': 'Please wait before requesting a new code.',
  'تعذر إرسال كود التفعيل. حاول مرة أخرى لاحقاً.': 'Could not send the activation code. Please try again later.',
  'يرجى إدخال البريد الإلكتروني وكلمة المرور': 'Enter your email address and password.',
  'البريد الإلكتروني أو كلمة المرور غير صحيحة.': 'The email address or password is incorrect.',
  'حسابك معطل حالياً. يرجى التواصل مع إدارة الموقع لإعادة التفعيل.': 'Your account is currently suspended. Contact support to reactivate it.',
  'يرجى تفعيل بريدك الإلكتروني أولاً. تم إرسال كود تفعيل جديد.': 'Verify your email first. A new activation code has been sent.',
  'حدث خطأ أثناء تسجيل الدخول': 'An error occurred while signing in.',
  'يجب تفعيل بريدك الإلكتروني أولاً قبل استعادة كلمة المرور.': 'Verify your email before resetting your password.',
  'تعذر إرسال كود إعادة التعيين. حاول مرة أخرى لاحقاً.': 'Could not send the reset code. Please try again later.',
  'برجاء إدخال البريد الإلكتروني والكود وكلمة مرور جديدة (8 أحرف على الأقل).': 'Enter your email, code, and a new password of at least 8 characters.',
  'لا يوجد كود إعادة تعيين ساري لهذا البريد. اطلب كوداً جديداً.': 'There is no valid reset code for this email. Request a new code.',
  'انتهت صلاحية الكود. اطلب كوداً جديداً.': 'The code has expired. Request a new code.',
  'الكود غير صحيح.': 'The code is incorrect.',
  'تعذر جلب إعدادات المظهر': 'Could not load appearance settings.',
  'تعذر جلب ترجمات الواجهة': 'Could not load interface translations.',
  'حدث خطأ أثناء إعادة تعيين كلمة المرور': 'An error occurred while resetting the password.',
  'حدث خطأ في جلب بيانات المستخدم': 'An error occurred while loading user data.',
  'لوحة تحكم (Owner Admin)': 'Owner dashboard',
  'إدارة الحسابات والترقية اليدوية': 'Account management and manual upgrades',
  'التحكم الكامل بجميع المستخدمين، ترقية الباقات يدوياً، تعديل الرصيد، وتصدير بيانات المستخدمين': 'Manage users, upgrade plans, edit credits, and export user data.',
  'تصدير بيانات المستخدمين (CSV)': 'Export users (CSV)',
  'بناءً على تاريخ الميلاد المسجّل في الملف الشخصي (': 'Based on profile birth dates (',
  'مستخدم)': 'users)',
  'الكل (': 'All (',
  'مجانية (': 'Free (',
  'من هو الجمهور الأنسب لهذا المشروع؟': 'Who is the best audience for this project?',
  'تيك توك': 'TikTok',
  'جوجل سيرش': 'Google Search',
  'سناب شات': 'Snapchat',
  'لينكد إن': 'LinkedIn',
  'تعذر الاتصال ببوابة الدفع': 'Could not connect to the payment gateway.',
  'تمت ترقية حسابك بنجاح. جاري تحديث بياناتك...': 'Your account was upgraded successfully. Updating your details...',
  'فشلت عملية الدفع. تأكد من بيانات البطاقة وحاول مجدداً.': 'Payment failed. Check your card details and try again.',
  '18 - 24 سنة': '18–24 years',
  '25 - 34 سنة': '25–34 years',
  '35 - 44 سنة': '35–44 years',
  '45 - 54 سنة': '45–54 years',
  '55 سنة فأكثر': '55 years and over',
  'أقل من 18 سنة': 'Under 18 years',
  'غير مصنّف': 'Unclassified',
  'آخر 14 يوم': 'Last 14 days',
  'آخر 30 يوم': 'Last 30 days',
  'آخر 90 يوم': 'Last 90 days',
  'آخر سنة': 'Last year',
  'كل الفترات': 'All time',
  'نطاق مخصص': 'Custom range',
  'إجمالي المنصة لكل المستخدمين': 'Platform total for all users',
  'استراتيجية استهداف بالذكاء الاصطناعي': 'AI targeting strategies',
  'موثّق': 'Verified',
  'غير موثّق': 'Unverified',
  'نشط (مفعل)': 'Active',
  'معطل': 'Suspended',
  'برجاء مشاركتها مع العميل وحثّه على تغييرها بعد أول دخول.': 'Share it with the client and ask them to change it after their first login.',
  'تعذر قراءة الملف': 'Could not read the file.',
  'تعذر تحميل الصورة': 'Could not load the image.',
  'Canvas غير مدعوم في هذا المتصفح': 'Canvas is not supported in this browser.',
  'القاهرة الجديدة / التجمع الخامس': 'New Cairo / Fifth Settlement',
  'العاصمة الإدارية الجديدة': 'New Administrative Capital',
  'الشيخ زايد / 6 أكتوبر': 'Sheikh Zayed / 6th of October',
  'مستقبل سيتي / الشروق': 'Mostakbal City / El Shorouk',
  'الساحل الشمالي / رأس الحكمة': 'North Coast / Ras El Hekma',
  'العين السخنة': 'Ain Sokhna',
  'الإسكندرية / سموحة والساحل': 'Alexandria / Smouha and the Coast',
  'الجونة / الغردقة': 'El Gouna / Hurghada',
  'المنصورة الجديدة / الصعيد': 'New Mansoura / Upper Egypt',
  'دبي / الرياض (استهداف الخليج)': 'Dubai / Riyadh (Gulf targeting)',
  'شاليه رأس الحكمة - الساحل الشمالي': 'Ras El Hekma chalet — North Coast',
  'استهداف المصطفيين والمستثمرين الخليجيين والمصريين': 'Target vacation-home buyers and Gulf and Egyptian investors',
  'مكتب إداري بالعاصمة الإدارية': 'Administrative office in the New Capital',
  'استهداف الأطباء، أصحاب الشركات، والمستثمرين بالمنطقة المركزية CBD': 'Target doctors, business owners, and CBD investors',
  'تاون هاوس في الشيخ زايد': 'Townhouse in Sheikh Zayed',
  'استهداف العائلات المصرية والباحثين عن الرقي والهدوء': 'Target Egyptian families seeking comfort and tranquility',
  'شقة سكنية بالتجمع الخامس': 'Residential apartment in Fifth Settlement',
  'استهداف المغتربين بالخليج والعائلات الشابة': 'Target Gulf expats and young families',
  'الأعلى طلباً': 'Highest demand',
  'عائد استثماري مرتفع': 'High investment return',
  'سكن فاخر': 'Premium residence',
  'سريع البيع': 'Fast-moving',
  'سولت رأس الحكمة - Salt Ras El Hekma': 'Salt Ras El Hekma',
  'تطوير مصر - Tatweer Misr': 'Tatweer Misr',
  'الكيلو 185 رأس الحكمة': 'Kilometer 185, Ras El Hekma',
  'شاليه 2 غرفة نوم صف ثاني على البحر مع لاجون': 'Two-bedroom chalet, second row from the sea, with a lagoon view',
  'صف أول وثاني على البحر مباشرة': 'Direct first- and second-row seafront location',
  'كريستال لاجون قابلة للسباحة': 'Swimmable crystal lagoon',
  'مقدم 5% وأقساط على 8 سنوات بدون فوائد': '5% down payment and interest-free installments over 8 years',
  'تشطيب كامل بالتكييفات': 'Fully finished with air conditioning',
  'منطقة تجارية ومطاعم عالمية': 'Retail district and international restaurants',
  'تاج تاور - Tag Tower': 'Tag Tower',
  'شركة تاج مصر - Taj Misr': 'Taj Misr',
  'منطقة الأعمال المركزية CBD أمام البرج الأيقوني': 'Central Business District, opposite the Iconic Tower',
  'مكتب إداري تشطيب كامل ومفروش بالكامل': 'Fully finished and furnished administrative office',
  'إطلالة مباشرة على البرج الأيقوني والنهر الأخضر': 'Direct view of the Iconic Tower and Green River',
  'عقد تفويض بالإيجار وإدارة عالمية': 'Lease-management agreement with international operations',
  'مقدم 10% وأقساط مريحة على 10 سنوات': '10% down payment and installments over 10 years',
  'قاعات اجتماعات ذكية وخدمات للشركات': 'Smart meeting rooms and business services',
  'خصم خاص للكاش والشركات الكبرى': 'Special discount for cash buyers and large companies',
  'سوديك فيليت - Villette Zayed': 'SODIC Villette — Sheikh Zayed',
  'سوديك - SODIC': 'SODIC',
  'زايد الجديدة بالقرب من وصلة دهشور': 'New Zayed, near Waslet Dahshur',
  'تاون هاوس بحديقة خاصة ومساحة 220م2': '220 m² townhouse with a private garden',
  '2026 (جاهز للتحميل قريبًا)': '2026 (delivery approaching)',
  'مجتمع سكني مغلق كاملاً (Gated Community)': 'Fully gated residential community',
  'كلوب هاوس وملاعب رياضية وحدائق واسعة': 'Clubhouse, sports courts, and expansive gardens',
  'قريب جداً من مول العرب ومحور 26 يوليو': 'Close to Mall of Arabia and the 26th of July Corridor',
  'تسهيلات سداد حتى 7 سنوات': 'Payment plans up to 7 years',
  'أمن وحراسة كاميرات 24/7': '24/7 security and surveillance',
  'ماونتن فيو إي سيتي - Mountain View iCity': 'Mountain View iCity',
  'ماونتن فيو - Mountain View': 'Mountain View',
  'التجمع الخامس بالقرب من الجولدن سكوير': 'Fifth Settlement, near Golden Square',
  'شقة 165م2 (3 غرفة نوم + 2 حمام) بفيو على اللاندسكيب': '165 m² apartment with 3 bedrooms, 2 bathrooms, and a landscape view',
  'نظام بارك بدون سيارات بالنفق السفلي': 'Car-free park with underground vehicle access',
  'على بعد 5 دقائق من الجامعة الأمريكية AUC': 'Five minutes from the American University in Cairo',
  'خصم حصري خلال فترة الطرح': 'Exclusive launch-period discount',
  'بحيرات صناعية ومسارات جاري ومناطق أطفال': 'Artificial lakes, running paths, and children areas',
  'أقساط متساوية بدون دفعات استلام معقدة': 'Equal installments with no complex delivery payments',
  'خبيرك في الاستهداف العقاري، بناء الحملات، وتحليل فرص السوق': 'Your expert in real estate targeting, campaign building, and market opportunity analysis',
  'ذكاء عقاري متخصص': 'Specialized real estate intelligence',
  'احترافي مباشر': 'Professional and direct',
  'إظهار السعر والمقدم ومدة التقسيط': 'Show the price, down payment, and installment period',
  'إعادة استهداف العملاء القدامى': 'Retarget previous leads',
  'إعادة تنشيط العملاء الذين أبدوا اهتمامًا سابقًا': 'Re-engage leads who previously showed interest',
  'اعتماد الحملة': 'Approve campaign',
  'التركيز على الجاهزية وتقليل وقت قرار الشراء': 'Emphasize readiness and shorten the purchase decision.',
  'الحاجة إلى إثبات واضح للعائد أو جودة الموقع': 'Needs clear proof of return or location quality',
  'القيمة العملية للمشروع وخطة السداد': 'The practical project value and payment plan',
  'المطور ونوع الوحدة': 'Developer and unit type',
  'المقارنة بين السعر والقيمة طويلة المدى': 'Comparing the price with long-term value',
  'المنطقة الفرعية غير محددة؛ دقة الاستهداف الجغرافي قد تتحسن بإضافتها.': 'The sub-area is missing; adding it may improve geographic targeting accuracy.',
  'الموقع التفصيلي': 'Detailed location',
  'إنشاء ونسخ رابط المراجعة': 'Create and copy review link',
  'بناء طلب واضح وتحويل الاهتمام إلى تسجيلات جادة': 'Build clear demand and turn interest into qualified registrations.',
  'بيع الوحدات المتبقية': 'Sell remaining inventory',
  'بيع وحدات خلال فترة الطرح': 'Sell units during launch',
  'تسجيل اهتمام قبل الإطلاق': 'Collect pre-launch interest',
  'تعذر إضافة ملاحظة المراجعة': 'Could not add the review comment.',
  'تعذر إنشاء رابط مراجعة العميل': 'Could not create the client review link.',
  'تعذر تحديث حالة المراجعة': 'Could not update the review status.',
  'تعذر جلب حالة مراجعة العميل': 'Could not load the client review status.',
  'تعذر جلب هوية الوكالة': 'Could not load the agency identity.',
  'تعذر حفظ هوية الوكالة': 'Could not save the agency identity.',
  'تعذر فتح مراجعة الحملة': 'Could not open the campaign review.',
  'تكوين قائمة انتظار قبل فتح البيع': 'Build a waiting list before sales open.',
  'تم إنشاء رابط المراجعة ونسخه': 'The review link was created and copied.',
  'تواصل معنا لمعرفة التفاصيل': 'Contact us for details',
  'جذب مستثمرين من الخليج': 'Attract Gulf investors',
  'حملة واتساب': 'WhatsApp campaign',
  'رسالة استثمارية تناسب الجمهور الخليجي': 'An investment message tailored to Gulf audiences.',
  'طلبات مراجعة كثيرة جداً. برجاء المحاولة مرة أخرى بعد قليل.': 'Too many review requests. Please try again shortly.',
  'عدد مميزات المشروع محدود؛ يفضّل إضافة سببين واقعيين للشراء.': 'The project has too few listed features; add at least two concrete reasons to buy.',
  'قرار الجمهور': 'Audience decision',
  'قرار المحتوى الإعلاني': 'Ad-content decision',
  'قرار الميزانية': 'Budget decision',
  'قرار عام': 'General decision',
  'مثال: شركة التطوير العقاري': 'Example: Real estate development company',
  'مثال: وكالة الهدف العقارية': 'Example: Al Hadaf Real Estate Agency',
  'محادثات مباشرة مع فريق المبيعات': 'Direct conversations with the sales team',
  'مشروع جاهز للاستلام': 'Ready-to-move project',
  'معالجة الاعتراضات وتحريك المخزون المتبقي': 'Address objections and move remaining inventory.',
  'ملاحظة العميل': 'Client note',
  'مميزات المشروع': 'Project features',
  'يجب حفظ الحملة قبل إنشاء رابط المراجعة': 'Save the campaign before creating a review link.',
  'يحدد القوة الشرائية والرسالة الاستثمارية': 'Defines purchasing power and the investment message.',
  'اختر باقة صحيحة (pro أو agency)': 'Choose a valid plan: Pro or Agency.',
  'الاسم لا يمكن أن يكون فارغاً': 'Name cannot be empty.',
  'الاسم والبريد الإلكتروني مطلوبان': 'Name and email are required.',
  'الباقة غير موجودة': 'Plan not found.',
  'البريد الإلكتروني مستخدم بالفعل': 'This email address is already in use.',
  'السعر يجب أن يكون رقماً موجباً': 'Price must be a positive number.',
  'المحادثة غير موجودة': 'Conversation not found.',
  'باقة غير صالحة': 'Invalid plan.',
  'بوابة الدفع غير مهيأة على السيرفر': 'The payment gateway is not configured on the server.',
  'بيانات الحملة غير صالحة': 'Campaign data is invalid.',
  'بيانات المشروع غير مكتملة': 'Project data is incomplete.',
  'بيانات المشروع مطلوبة': 'Project data is required.',
  'تاريخ الميلاد غير صالح': 'Date of birth is invalid.',
  'تعذر إرسال كود التفعيل إلى البريد الجديد. حاول مرة أخرى.': 'Could not send the activation code to the new email. Try again.',
  'تعذر إنشاء محادثة جديدة': 'Could not create a new conversation.',
  'تعذر تحديث إعدادات الباقة': 'Could not update plan settings.',
  'تعذر جلب أسعار الباقات': 'Could not load plan prices.',
  'تعذر جلب الإعدادات': 'Could not load settings.',
  'تعذر جلب جلسات المحادثة': 'Could not load conversations.',
  'تعذر جلب رسائل المحادثة': 'Could not load conversation messages.',
  'تعذر جلب سجل المدفوعات': 'Could not load payment history.',
  'تعذر حفظ إعدادات المظهر': 'Could not save appearance settings.',
  'تعذر حفظ ترجمات الواجهة': 'Could not save interface translations.',
  'حالة المراجعة غير صالحة': 'Review status is invalid.',
  'حجم الصورة كبير جداً. اختر صورة أصغر.': 'The image is too large. Choose a smaller image.',
  'حدث خطأ أثناء إعادة صياغة النص': 'An error occurred while rewriting the text.',
  'حدث خطأ أثناء المحادثة': 'An error occurred during the conversation.',
  'حدث خطأ أثناء بدء جلسة الدفع': 'An error occurred while starting the payment session.',
  'حدث خطأ أثناء تحديث الرصيد': 'An error occurred while updating credits.',
  'حدث خطأ أثناء تحديث الصورة الشخصية': 'An error occurred while updating the profile image.',
  'حدث خطأ أثناء تحديث المستخدم': 'An error occurred while updating the user.',
  'حدث خطأ أثناء تحديث بياناتك': 'An error occurred while updating your information.',
  'حدث خطأ أثناء تحليل إعلان المنافس': 'An error occurred while analyzing the competitor ad.',
  'حدث خطأ أثناء تغيير البريد الإلكتروني': 'An error occurred while changing the email address.',
  'حدث خطأ أثناء تغيير كلمة المرور': 'An error occurred while changing the password.',
  'حدث خطأ أثناء توليد الاستراتيجية بواسطة الذكاء الاصطناعي': 'An error occurred while generating the AI strategy.',
  'حدث خطأ أثناء توليد الإعلانات': 'An error occurred while generating the ads.',
  'حدث خطأ أثناء توليد تحليلات السوق بواسطة الذكاء الاصطناعي': 'An error occurred while generating AI market insights.',
  'حدث خطأ أثناء توليد سكريبت الفيديو': 'An error occurred while generating the video script.',
  'حدث خطأ أثناء جلب إحصائيات المنصة': 'An error occurred while loading platform statistics.',
  'حدث خطأ أثناء جلب الحملات المحفوظة': 'An error occurred while loading saved campaigns.',
  'حدث خطأ أثناء جلب قائمة المستخدمين': 'An error occurred while loading the user list.',
  'حدث خطأ أثناء حذف الحساب': 'An error occurred while deleting the account.',
  'حسابك معطل حالياً': 'Your account is currently suspended.',
  'رابط المراجعة غير صالح أو انتهت صلاحيته': 'The review link is invalid or has expired.',
  'صيغة الصورة غير صالحة. يُسمح فقط بـ PNG أو JPEG أو WebP.': 'Invalid image format. Only PNG, JPEG, or WebP is allowed.',
  'فشل الاتصال ببوابة الدفع (Auth)': 'Could not authenticate with the payment gateway.',
  'فشل إنشاء طلب الدفع': 'Could not create the payment order.',
  'فشل توليد مفتاح الدفع': 'Could not generate the payment key.',
  'قائمة الترجمات غير صالحة': 'The translation list is invalid.',
  'قيمة الرصيد غير صالحة': 'Credit value is invalid.',
  'كل ترجمة تحتاج مفتاحاً ونصاً عربياً وإنجليزياً صالحاً': 'Every translation requires a valid key, Arabic text, and English text.',
  'كلمة المرور الحالية غير صحيحة': 'The current password is incorrect.',
  'كلمة المرور غير صحيحة': 'The password is incorrect.',
  'لا توجد بيانات لتحديثها': 'There is no data to update.',
  'لا توجد بيانات للتحديث': 'There is no data to update.',
  'لا يمكن حذف حساب المسؤول من هنا. تواصل مع الدعم الفني.': 'The administrator account cannot be deleted here. Contact support.',
  'لا يمكنك حذف حسابك الحالي': 'You cannot delete your current account.',
  'لقد استهلكت رصيد حملاتك المجانية، برجاء الترقية للباقة المدفوعة': 'You have used all free campaign credits. Upgrade to a paid plan to continue.',
  'لقد وصلت للحد الأقصى للرسائل المجانية هذا الشهر (100 رسالة). يرجى الترقية.': 'You have reached the monthly free-message limit of 100 messages. Please upgrade.',
  'لم يتم تقديم أي إعدادات للتحديث': 'No settings were provided for update.',
  'مفتاح الباقة غير صحيح': 'Plan key is invalid.',
  'هذا البريد الإلكتروني مستخدم بالفعل': 'This email address is already in use.',
  'هذا هو بريدك الإلكتروني الحالي بالفعل': 'This is already your current email address.',
  'هذه الميزة متاحة فقط للباقات المدفوعة (Pro أو Agency)، برجاء الترقية للاستمرار.': 'This feature is available only on Pro or Agency plans. Upgrade to continue.',
  'يجب توفير معرف المحادثة والنص': 'Conversation ID and text are required.',
  'يرجى إدخال البريد الإلكتروني الجديد وكلمة المرور الحالية': 'Enter the new email address and your current password.',
  'يرجى إدخال كلمة المرور الحالية وكلمة مرور جديدة (8 أحرف على الأقل)': 'Enter your current password and a new password of at least 8 characters.',
  'يرجى إدخال كلمة المرور لتأكيد حذف الحساب': 'Enter your password to confirm account deletion.',
  'يرجى تزويد النص وتعليمات إعادة الصياغة': 'Provide the text and rewrite instructions.',
  'يرجى تزويد نص أو رابط صورة الإعلان المنافس': 'Provide competitor ad text or an image URL.',
  'جمع بيانات العملاء': 'Lead generation',
  'محادثات واتساب': 'WhatsApp conversations',
  'تحويلات الموقع': 'Website conversions',
  'متحفظ': 'Conservative',
  'متوقع': 'Expected',
  'متفائل': 'Optimistic',
  'اكتساب عملاء جدد واختبار شرائح الجمهور': 'Acquire new leads and test audience segments',
  'إعادة استهداف المتفاعلين وبدء المحادثات': 'Retarget engaged users and start conversations',
  'اختبار الخطافات والتصميمات قبل التوسّع': 'Test hooks and creatives before scaling',
  'إعلان ثابت': 'Static ad',
  'فيديو قصير': 'Short video',
  'مراجعة بيانات المشروع والأسعار': 'Review project details and pricing',
  'اختبار نموذج جمع البيانات وواتساب': 'Test the lead form and WhatsApp',
  'تثبيت Pixel وConversions API': 'Install Pixel and Conversions API',
  'تأكيد الفئة الإعلانية الخاصة بالإسكان': 'Confirm the Housing Special Ad Category',
  'مراجعة النسخ والتصميمات المعتمدة': 'Review approved copy and creatives',
  'إضافة UTM إلى كل إعلان': 'Add UTM tags to every ad',
  'تحديد مسؤول متابعة العملاء': 'Assign a lead follow-up owner',
  'جدولة مراجعة النتائج بعد 72 ساعة': 'Schedule a performance review after 72 hours',
  'الإنفاق': 'Spend',
  'CPL الفعلي': 'Actual CPL',
  'تعذر جلب إصدارات الحملة': 'Could not load campaign versions.',
  'تعذر إنشاء إصدار الحملة': 'Could not create campaign version.',
  'تعذر استعادة إصدار الحملة': 'Could not restore campaign version.',
  'تعذر حفظ نتائج الإصدار': 'Could not save version results.',
  'تعذر إرسال الحملة للمراجعة': 'Could not send the campaign for review.',
  'تم إنشاء مسودة بوابة مراجعة العميل': 'The client review portal draft was created.',
  'تم إرسال الحملة إلى العميل للمراجعة': 'The campaign was sent to the client for review.',
  'تمت إعادة الحملة إلى المسودة': 'The campaign was returned to draft.',
  'تم اعتماد الحملة إلكترونيًا': 'The campaign was electronically approved.',
  'طلب العميل تعديلات على الحملة': 'The client requested campaign changes.',
  'معتمد': 'Approved',
  'يحتاج تعديلات': 'Needs changes',
  'اكتب اسم المعتمد ووافق على إقرار الاعتماد الإلكتروني': 'Enter the approver name and accept the electronic approval statement.',
  'مالك': 'Owner',
  'مدير': 'Manager',
  'مسوّق': 'Marketer',
  'كاتب محتوى': 'Copywriter',
  'عميل': 'Client',
  'تم إرسال دعوة عضو الفريق': 'Team member invitation sent.',
  'تعذر جلب مساحة الفريق': 'Could not load the team workspace.',
  'تعذر دعوة عضو الفريق': 'Could not invite the team member.',
  'تعذر إسناد الحملة': 'Could not assign the campaign.',
  'تعذر حفظ التعليق الداخلي': 'Could not save the internal comment.',
  'دعا عضوًا جديدًا إلى الفريق': 'invited a new team member',
  'أسند حملة إلى عضو الفريق': 'assigned a campaign to a team member',
  'أضاف تعليقًا داخليًا': 'added an internal comment',
  'تعذر إعادة إرسال الدعوة': 'Could not resend the invite.',
  'تعذر حذف عضو الفريق': 'Could not remove the team member.',
  'العضو غير موجود': 'Member not found.',
  'هذا العضو منضم بالفعل ولا يحتاج إعادة دعوة': 'This member has already joined and does not need a resend.',
  'تمت إضافة العضو لكن تعذر إرسال بريد الدعوة، جرّب إعادة الإرسال': 'Member added, but the invite email failed to send — try resending it.',
  'أعاد إرسال دعوة الفريق': 'resent the team invite',
  'أزال عضوًا من الفريق': 'removed a member from the team',
  'egyptian_investor': 'Egyptian investor',
  'gulf_expat': 'Gulf expatriates',
  'family_home': 'Family homebuyers',
  'business_medical': 'Business & medical',
  'luxury_vacation': 'Luxury & vacation',
  'مساحات فرق العمل متاحة لباقة الوكالات فقط.': 'Team workspaces are available only on the Agency plan.',
  'هذا البريد مضاف إلى الفريق بالفعل': 'This email is already on the team.',
  'بيانات عضو الفريق غير مكتملة': 'Team member details are incomplete.',
  'صلاحية عضو الفريق غير صالحة': 'The team member role is invalid.',
  'الحملة أو العضو غير موجود': 'The campaign or member was not found.',
  'اكتب التعليق الداخلي أولاً': 'Write the internal comment first.',
  'تعذر جلب خطوات التهيئة': 'Could not load onboarding progress.',
  'تعذر حفظ خطوات التهيئة': 'Could not save onboarding progress.',
  'حدث المنتج غير صالح': 'Invalid product event.',
  'تعذر تسجيل حدث الاستخدام': 'Could not record product event.',
  'تعذر جلب تحليلات الاستخدام': 'Could not load product analytics.',
  'حفظ حملة': 'Campaign saved',
  'إرسالها للعميل': 'Sent to client',
  'اعتماد العميل لها': 'Client approved',
  'العودة لإنشاء حملة ثانية': 'Returned to create a second campaign',
  'دعوة عضو فريق': 'Team member invited',
  'الترقية إلى باقة مدفوعة': 'Upgraded to a paid plan',
  'تعذر جلب تحليلات استخدام المنتج': 'Could not load product usage analytics.',
};

export const STATIC_UI_GROUP_LABELS: Record<string, string> = {
  app: 'عام / تحميل الصفحات',
  nav: 'القائمة الجانبية والشريط العلوي',
  auth: 'تسجيل الدخول وإنشاء الحساب',
  builder: 'مولد الحملات (نموذج الإنشاء)',
  workspace: 'مساحة عمل الحملة والنتائج',
  editor: 'محرر النصوص المولّدة',
  versions: 'إصدارات الحملة',
  library: 'مكتبة المحتوى',
  saved: 'الحملات المحفوظة',
  insights: 'استراتيجيات CPL',
  chat: 'شات الذكاء الاصطناعي',
  team: 'مساحة الفريق',
  credits: 'سجل الرصيد',
  payment: 'الدفع اليدوي',
  pricing: 'الباقات والأسعار',
  brand: 'إعدادات العلامة التجارية',
  profile: 'الملف الشخصي',
  reels: 'سكريبت الريلز',
  multiplatform: 'النشر متعدد المنصات',
  competitor: 'تحليل المنافسين',
  preview: 'معاينة الإعلان',
  dashboard: 'الرئيسية',
  client_review: 'صفحة مراجعة العميل',
  simulator: 'محاكي الحملة',
  launch: 'حزمة الإطلاق',
  support_widget: 'ودجت الدعم الفني',
  support: 'لوحة الدعم الفني (أدمن)',
  admin: 'لوحة تحكم الأدمن',
  translation_manager: 'إدارة الترجمة',
  onboarding: 'التهيئة الأولى',
  general: 'عام / غير مصنّف',
};

/** خريطة: كل نص عربي -> معرّف الصفحة التي ينتمي لها (للتصنيف في لوحة إدارة الترجمة). */
const staticUiTranslationGroups: Record<string, string> = {
  ...Object.fromEntries(Object.keys(staticUi_app).map((k) => [k, 'app'])),
  ...Object.fromEntries(Object.keys(staticUi_nav).map((k) => [k, 'nav'])),
  ...Object.fromEntries(Object.keys(staticUi_auth).map((k) => [k, 'auth'])),
  ...Object.fromEntries(Object.keys(staticUi_builder).map((k) => [k, 'builder'])),
  ...Object.fromEntries(Object.keys(staticUi_workspace).map((k) => [k, 'workspace'])),
  ...Object.fromEntries(Object.keys(staticUi_editor).map((k) => [k, 'editor'])),
  ...Object.fromEntries(Object.keys(staticUi_versions).map((k) => [k, 'versions'])),
  ...Object.fromEntries(Object.keys(staticUi_library).map((k) => [k, 'library'])),
  ...Object.fromEntries(Object.keys(staticUi_saved).map((k) => [k, 'saved'])),
  ...Object.fromEntries(Object.keys(staticUi_insights).map((k) => [k, 'insights'])),
  ...Object.fromEntries(Object.keys(staticUi_chat).map((k) => [k, 'chat'])),
  ...Object.fromEntries(Object.keys(staticUi_team).map((k) => [k, 'team'])),
  ...Object.fromEntries(Object.keys(staticUi_credits).map((k) => [k, 'credits'])),
  ...Object.fromEntries(Object.keys(staticUi_payment).map((k) => [k, 'payment'])),
  ...Object.fromEntries(Object.keys(staticUi_pricing).map((k) => [k, 'pricing'])),
  ...Object.fromEntries(Object.keys(staticUi_brand).map((k) => [k, 'brand'])),
  ...Object.fromEntries(Object.keys(staticUi_profile).map((k) => [k, 'profile'])),
  ...Object.fromEntries(Object.keys(staticUi_reels).map((k) => [k, 'reels'])),
  ...Object.fromEntries(Object.keys(staticUi_multiplatform).map((k) => [k, 'multiplatform'])),
  ...Object.fromEntries(Object.keys(staticUi_competitor).map((k) => [k, 'competitor'])),
  ...Object.fromEntries(Object.keys(staticUi_preview).map((k) => [k, 'preview'])),
  ...Object.fromEntries(Object.keys(staticUi_dashboard).map((k) => [k, 'dashboard'])),
  ...Object.fromEntries(Object.keys(staticUi_client_review).map((k) => [k, 'client_review'])),
  ...Object.fromEntries(Object.keys(staticUi_simulator).map((k) => [k, 'simulator'])),
  ...Object.fromEntries(Object.keys(staticUi_launch).map((k) => [k, 'launch'])),
  ...Object.fromEntries(Object.keys(staticUi_support_widget).map((k) => [k, 'support_widget'])),
  ...Object.fromEntries(Object.keys(staticUi_support).map((k) => [k, 'support'])),
  ...Object.fromEntries(Object.keys(staticUi_admin).map((k) => [k, 'admin'])),
  ...Object.fromEntries(Object.keys(staticUi_translation_manager).map((k) => [k, 'translation_manager'])),
  ...Object.fromEntries(Object.keys(staticUi_onboarding).map((k) => [k, 'onboarding'])),
  ...Object.fromEntries(Object.keys(staticUi_general).map((k) => [k, 'general'])),
};
export { staticUiTranslationGroups };

/** القاموس المسطّح الكامل، مُجمَّع تلقائيًا من كل الأقسام أعلاه — لا تُعدّل يدويًا، عدّل القسم المناسب فوق. */
export const staticUiTranslations: Record<string, string> = {
  ...staticUi_app,
  ...staticUi_nav,
  ...staticUi_auth,
  ...staticUi_builder,
  ...staticUi_workspace,
  ...staticUi_editor,
  ...staticUi_versions,
  ...staticUi_library,
  ...staticUi_saved,
  ...staticUi_insights,
  ...staticUi_chat,
  ...staticUi_team,
  ...staticUi_credits,
  ...staticUi_payment,
  ...staticUi_pricing,
  ...staticUi_brand,
  ...staticUi_profile,
  ...staticUi_reels,
  ...staticUi_multiplatform,
  ...staticUi_competitor,
  ...staticUi_preview,
  ...staticUi_dashboard,
  ...staticUi_client_review,
  ...staticUi_simulator,
  ...staticUi_launch,
  ...staticUi_support_widget,
  ...staticUi_support,
  ...staticUi_admin,
  ...staticUi_translation_manager,
  ...staticUi_onboarding,
  ...staticUi_general,
};


export interface TranslationCatalogEntry {
  key: string;
  source: 'keyed' | 'static';
  group: string;
  ar: string;
  en: string;
}

/** Stable browser-safe identifier for Arabic-source static text. */
export function getStaticTranslationKey(text: string): string {
  let hash = 2166136261;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return `text.${(hash >>> 0).toString(36)}`;
}

export const translationCatalog: TranslationCatalogEntry[] = [
  ...Object.keys(translations.ar).map((key) => ({
    key: `key.${key}`,
    source: 'keyed' as const,
    group: key.split('.')[0] || 'general',
    ar: translations.ar[key as TranslationKey],
    en: translations.en[key as TranslationKey] ?? translations.ar[key as TranslationKey],
  })),
  ...Object.entries(staticUiTranslations).map(([ar, en]) => ({
    key: getStaticTranslationKey(ar),
    source: 'static' as const,
    group: staticUiTranslationGroups[ar] || 'general',
    ar,
    en,
  })),
].filter((entry, index, entries) => entries.findIndex((candidate) => candidate.key === entry.key) === index);

export function useTranslation() {
  const { language, translationOverrides } = useLanguage();
  const t = (key: TranslationKey): string =>
    translationOverrides[`key.${key}`]?.[language] || translations[language][key] || key;
  const tx = (text: string): string => {
    const override = translationOverrides[getStaticTranslationKey(text)]?.[language];
    if (override) return override;
    return language === 'en' ? (staticUiTranslations[text] ?? text) : text;
  };
  return { t, tx, language };
}
